// Const
const LAGER_MAP_CANVAS_HEIGHT = 5000;
const LAGER_MAP_CANVAS_WIDTH = 5000;

const LAGER_MAP_MENU_TOP_HEIGHT = '60px';
const LAGER_MAP_MENU_LEFT_WIDTH = '300px';

const LAGER_MAP_MAX_ZOOM = 1.5;
const LAGER_MAP_MIN_ZOOM = 0.5;
const LAGER_MAP_WHEEL_ZOOM_STEP = 0.1;

const LAGER_MAP_WALL_WIDTH = 2;
const LAGER_MAP_WALL_END_SIZE = 5;
const LAGER_MAP_WALL_DEADZONE = 2;

const LAGER_MAP_BACKGROUND_STEP = 10;
const LAGER_MAP_DECIMAL_PLACES = 1;

const LAGER_MAP_REOL_LINE_STYLE = "#000000FF";
const LAGER_MAP_REOL_FILL_STYLE = "#78787AFF";
const LAGER_MAP_REOL_FILL_STYLE_ERROR = "#C2645DFF";
const LAGER_MAP_REOL_GATE_FILL_STYLE = '#000000FF';
const LAGER_MAP_REOL_FONT_SIZE = 12;
const LAGER_MAP_REOL_FONT_WEIGHT = 'bold';
const LAGER_MAP_REOL_GATE_SIZE = 3;
const LAGER_MAP_REOL_DEADZONE = 2;

const LAGER_MAP_FONT = 'Verdana';

const LAGER_MAP_FILL_STYLE_SELECTED = '#34B7EB50';
const LAGER_MAP_STROKE_STYLE_SELECTED = '#346EEBFF';

class EntitieTypes {
    static START = Symbol('start');
    static WALL = Symbol('wall');
    static POSITION = Symbol('pos');
}

class ToolTypes {
    static START = Symbol('start');
    static WALL = Symbol('wall');
    static POSITION = Symbol('position');
    static CURSOR = Symbol('cursor');
}

export class LagerMap {
    // State
    _next_id = null;  // Don't ues 0 (reserved)
    _entities = null; // Object with id as key - one item: { 'id': 1, 'type': 'some_type', 'x': 10, 'y': 10, 'args': { } }, ...

    _scale = null;

    _selected_node = null;
    _selected_tool = null;
    _selected_context = null;  // { 'opcode': int, 'id': int? }

    _uint_size_m = null;  // Map unit size in m

    _context_menu_pos_input = null;  // { 'length': float, 'width': float, 'angle': int, 'aisle': string, 'racks': int }

    // DOM
    _canvas_container = null;
    _canvas = null;
    _context_menu = null;
    _dialog = null;

    // Offscreen canvas
    _offsereen_canvas_start = null;
    _offscreen_canvas_background = null;
    _offscreen_canvas_wall = null;
    _offscreen_canvas_pos = null;
    _offscreen_canvas_gui = null;

    // Event listeners
    _event_listeners = null;

    // Callback
    _callback_message = null;

    // Cache
    _cache_pos_cursor = null;

    /**
     *  Create new map
     * 
     * @param {string} target_id The target dom element by id as string
     * @param {float} uint_size_m The pixel unit size in meters
     * @param {CallableFunction} callback_message function signature: title: string, message: string -> void
     */
    constructor(target_id, uint_size_m, callback_message) {
        if (target_id != null) {
            this._container = document.querySelector('#' + target_id);
            if (!this._container) throw 'Can\'t find #' + target_id;
        } else {
            this._container = document.createElement('div');
        }

        if (typeof callback_message != 'function') throw 'The callback_message is not a function';

        this._callback_message = callback_message;

        this._uint_size_m = uint_size_m;
        this._scale = 1;
        this._next_id = 0;
        this._entities = new Object();
        this._event_listeners = [];
        this._cache_pos_cursor = new Object();

        this._CreateIconStyling();
        this._CreatePopupEditRacks();
        this._CreateMenu();
        this._CreateCanvas();
        this._CreateContextMenu();
        this._CreateEventListener();

        this._DrawCanvas(1);

        this._canvas_grid = this._canvas.toDataURL();
    }

    //***************************************************
    // Public functions
    //***************************************************

    /**
     * Destroy event listeners and clenup
     */
    Destroy() {
        for (let i = 0; i < this._event_listeners.length; i++) {
            let event_listener = this._event_listeners[i];
            event_listener.target.removeEventListener(
                event_listener.event_name,
                event_listener.callback,
                event_listener.options,
            )
        }

        this._container.innerHTML = '';
    }

    /**
     * Set background image of the canvas
     * 
     * @param {any} img Must be compatible with drawImage on a canvas context
     * @param {float|int} height_m The image height in meters
     * @param {float|int} width_m The image width in meters
     * @param {float|int} offset_height_m The offset of height from the left in meters
     * @param {float|int} offset_width_m The offset of width from the left in meters
     * @param {float|iny} alpha The alpha channel from image (from .0 to .1)
     */
    SetBackground(img, height_m, width_m, offset_height_m=0, offset_width_m=0, alpha=0.4) {
        this._DrawBackground();
        let context = this._offscreen_canvas_background.getContext('2d');
        context.save();
        context.globalAlpha = alpha;
        context.drawImage(
            img,
            Math.round(offset_height_m / this._uint_size_m), 
            Math.round(offset_width_m / this._uint_size_m), 
            Math.round(height_m / this._uint_size_m), 
            Math.round(width_m / this._uint_size_m),
        );
        context.restore();
        
        this._DrawCanvas();
    }

    /**
     * Serialize the state
     * 
     * @returns string the result is returned as a Json string
     */
    Serialize() {
        let result = {
            'uint_size_m': this._uint_size_m.toString(),
            'position': [],
            'wall': [],
            'start': null,
        };
        this._data_init = JSON.stringify(result);
        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let entity = this._entities[ids[i]];
            
            switch (entity.type) {
                case EntitieTypes.POSITION: {
                    let rackes_data = []
                    for (let i = 0; i < entity.args.racks_data.length; i++) {
                        rackes_data.push({'i': i, 'v': entity.args.racks_data[i]});
                    }

                    result.position.push({
                        'x': entity.x, 
                        'y': entity.y, 
                        'length': entity.args.length.toFixed(2),
                        'width': entity.args.width.toFixed(2),
                        'angle': entity.args.angle, 
                        'aisle': entity.args.aisle, 
                        'racks': entity.args.racks,
                        'racks_data': rackes_data,
                    });
                    break;
                }
                case EntitieTypes.WALL:
                    result.wall.push({
                        'from_x': entity.x, 
                        'from_y': entity.y, 
                        'to_x': entity.args.to.x, 
                        'to_y': entity.args.to.y,
                    });
                    break;

                case EntitieTypes.START:
                    result.start = {
                        'x': entity.x,
                        'y': entity.y,
                    };
                    break;
            
                default:
                    console.error(`Not supported EntitieTypes: ${entity.type} at offset ${i}`, entity);
                    break;
            }
        }

        return JSON.stringify(result);
    }

    /**
     * Deserialize state from json string
     * 
     * @param {string} serialize_data 
     */
    Deserialize(serialize_data) {
        this._next_id = 0;
        this._entities = new Object();
        this._cache_pos_cursor = new Object();

        let deserialize_data = JSON.parse(serialize_data);

        let _uint_size_m = parseFloat(deserialize_data.uint_size_m);

        let factor = 1;
        if (_uint_size_m != this._uint_size_m) {
            //this._Message(title, message, silent=false)
            //this._callback_message(title, message);
            this._Message('Import error', 'The _uint_size_m is not same for this map');
            //console.warn('The _uint_size_m is not same for this map');
            factor = _uint_size_m / this._uint_size_m;
        }

        if (deserialize_data.position) {
            for (let i = 0; i < deserialize_data.position.length; i++) {
               let pos = deserialize_data.position[i];
               
                let new_pos = this._AddEntryPos(
                    parseInt(pos.x * factor),
                    parseInt(pos.y * factor),
                    parseFloat(pos.length),
                    parseFloat(pos.width),
                    pos.angle,
                    pos.aisle,
                    pos.racks,
                );

                for (let i = 0; i < pos.racks_data.length; i++) {
                    let label = pos.racks_data[i];
                    new_pos.args.racks_data[label.i] = label.v;
                }
            }
        }

        if (deserialize_data.wall) {
            for (let i = 0; i < deserialize_data.wall.length; i++) {
                let wall = deserialize_data.wall[i];
                
                this._AddEntryWall(
                    parseInt(wall.from_x * factor), 
                    parseInt(wall.from_y * factor), 
                    parseInt(wall.to_x * factor), 
                    parseInt(wall.to_y * factor),
                );
            }
        }

        if (deserialize_data.start) {
            let id = this._NextEntryId();
            this._entities[id] = {
                'id': id,
                'type': EntitieTypes.START,
                'x': parseInt(deserialize_data.start.x * factor),
                'y': parseInt(deserialize_data.start.y * factor),
                'args': null,
            };
        }

        this._EventSelectedTool(null, null);
        this._DrawStart();
        this._DrawWall();
        this._DrawPos();
        this._DrawCanvas();

        this._menu_tool_cursor.click();
    }

    /**
     * @param {Array} path_data array with {'r': string, 'h': string}
     */
    DrawPath(path_data) {
        let fill = [
            '#0000FF',
            '#E85600',
            '#E88F00',
            '#024498',
            '#009771',
            '#00FF00',
            '#E8DC00',
            '#53029D',
            '#A7DD00',
            '#AB0080',
            '#FF0000',
        ];

        let pick_path = new PickPath(this._uint_size_m, this._entities, path_data);

        // For debugging
        // let main = this._canvas.getContext('2d');
        // main.clearRect(0, 0, this._canvas.width, this._canvas.height);
        // main.fillStyle = '#555';
        
        // for (let y = 0; y < pick_path.map_wall.length; y++) {
        //     const row = pick_path.map_wall[y];
        //     for (let x = 0; x < row.length; x++) {
        //         if (row[x]) {
        //             main.fillRect(x, y, 1, 1);
        //         }
        //     }
        // }
       
        // let index = 0;
        // for (let path of pick_path.Result) {
        //     index++;

        //     main.fillStyle = fill[index % fill.length];
        //     if (path.type != 'path') continue;

        //     for (let setep of path.path)
        //     main.fillRect(setep.x, setep.y, 3, 3);
        // }

        let canvas = document.createElement('canvas');
        canvas.width = LAGER_MAP_CANVAS_WIDTH;
        canvas.height = LAGER_MAP_CANVAS_HEIGHT;
        let context = canvas.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_pos.width, this._offscreen_canvas_pos.height);

        context.drawImage(this._offscreen_canvas_background, 0, 0, this._canvas.width, this._canvas.height);

        let index = 0;
        for (let path of pick_path.Result) {
            if (path.type != 'path') continue;

            index++;
            context.fillStyle = fill[index % fill.length];

            for (let setep of path.path)
            context.fillRect(setep.x, setep.y, 3, 3);
        }

        // start arrow
        context.fillStyle = '#000';
        for (let path of pick_path.Result) {
            if (path.type != 'path') continue;
            if (path.path.length <= 2) break;
            
            let arrow_start = path.path[0];
            let arrow_end = path.path[20];

            let delta_x = arrow_end.x - arrow_start.x;
            let delta_y = arrow_end.y - arrow_start.y;

            let x = delta_x + arrow_start.x;
            let y = delta_y + arrow_start.y;

            let headlen = 10;
            let angle = Math.atan2(y - arrow_start.y, x - arrow_start.x);
            let pi_factor = Math.PI / 7;

            context.save();

            context.beginPath();
            context.moveTo(arrow_start.x, arrow_start.y);
            context.lineTo(x, y);
            context.lineWidth = headlen;
            context.stroke();

            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(
                x - headlen * Math.cos(angle - pi_factor),
                y - headlen * Math.sin(angle - pi_factor),
            );

            context.lineTo(
                x - headlen * Math.cos(angle + pi_factor),
                y - headlen * Math.sin(angle + pi_factor),
            );

            context.lineTo(x, y);
            context.lineTo(
                x - headlen * Math.cos(angle - pi_factor),
                y - headlen * Math.sin(angle - pi_factor),
            );

            context.stroke();
            context.restore();

            break;
        }

        context.drawImage(this._offscreen_canvas_pos, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offscreen_canvas_wall, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offsereen_canvas_start, 0, 0, this._canvas.width, this._canvas.height);
        
        let result = canvas.toDataURL('image/png');
        var image = new Image();
        image.src = result;

        this.Destroy();

        return image;
    }

    //***************************************************
    // Create GUI
    //***************************************************

    _CreateIconStyling() {
        if (!this._container?.id) return;
        let container = `#${this._container.id}`;
        let prefix = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"%3E%3C';
        let css = `${container} .icon::before {
            width: 100%;
            height: 100%;
            content: '';
            display: block;
            position: relative;
            -webkit-mask-size: 40%;
            -webkit-mask-repeat: no-repeat;
            -webkit-mask-position: center;
            background-color: white;
        }
        ${container} .icon {
            cursor: pointer;
            border-radius: 50%;
        }
        ${container} .icon + .icon {
            margin-left: 15px;
        }
        ${container} .icon.active {
            background-color: rgba(0, 0, 0, 1) !important;
            cursor: default;
        }
        ${container} .icon.toggle.active {
            outline: 2px solid;
            outline-offset: 2px;
        }
        ${container} .icon.active::before {
            background-color: rgba(255, 255, 255, 1);
        }
        ${container} .icon.cursor::before {
            transform: rotate(15deg);
            -webkit-mask-size: 32%;
            -webkit-mask-image: url('${prefix}path d="M394.1 324.3 256.5 186.7l100.2-43.2a20.3 20.3 0 0 0 12.2-19.6c-.4-8.5-6-15.8-14.1-18.3L26.5 1C19.3-1.3 11.4.6 6 6s-7.3 13.3-5 20.5l104.6 328.3c2.6 8.1 9.9 13.7 18.3 14.1 8.5.4 16.3-4.5 19.6-12.2l43.2-100.2 137.6 137.6c3.8 3.8 9 5.9 14.3 5.9 5.4 0 10.5-2.1 14.3-5.9L394 353c8-7.9 8-20.8.1-28.7z"/%3E%3C/svg%3E');
            /*-webkit-mask-image: url('${prefix}path d="M373.696 247.698a21.815 21.815 0 0 1-20.407 14.108h-95.445l41.041 86.191c8.632 18.125.937 39.814-17.189 48.459-18.135 8.639-39.833.941-48.468-17.189l-42.332-89.028-68.175 80.219a21.78 21.78 0 0 1-16.617 7.684c-2.528 0-5.07-.44-7.527-1.335-8.598-3.122-14.307-11.303-14.307-21.302V21.83c0-8.58 5.028-16.39 12.835-19.917 7.845-3.499 17.007-2.127 23.407 3.527l246.43 218.16c7.663 6.009 9.208 15.553 6.754 24.098Z"/%3E%3C/svg%3E');*/
        }
        ${container} .icon.wall::before {
            -webkit-mask-image: url('${prefix}path d="M15.2 124.1h95.9c8.2 0 14.9-6.2 14.9-13.7V82.7c0-7.6-6.7-13.7-14.9-13.7H15.2C7 69 .4 75.2.4 82.7v27.6c0 7.6 6.6 13.8 14.8 13.8zm247.4-13.8V82.7c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.3.1 14.9-6.1 14.9-13.7zm136.7 0V82.7c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2.1 14.9-6.1 14.9-13.7zM82.7 55.1h95.9c8.2 0 14.9-6.2 14.9-13.7V13.7c0-7.6-6.7-13.7-14.9-13.7H82.7c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.8 14.9 13.8zm138.1 0h95.9c8.2 0 14.9-6.2 14.9-13.7V13.7c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.8 14.9 13.8zm-205.6 0h26.1c8.2 0 14.9-6.2 14.9-13.7V13.7C56.2 6.2 49.6 0 41.3 0H15.2C7 0 .4 6.2.4 13.7v27.6c0 7.6 6.6 13.8 14.8 13.8zM385.1 0H359c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h26.1c8.2 0 14.9-6.2 14.9-13.7V13.7C400 6.2 393.3 0 385.1 0zm-274 207H15.2C7 207 .3 213.2.3 220.7v27.6C.3 255.9 7 262 15.2 262h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7zm136.7 0h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c-.1-7.6-6.7-13.7-14.9-13.7zm136.6 0h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7zM82.7 138c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H82.7zm138.1 55h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7zm-205.6 0h26.1c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H15.2C7 138 .3 144.2.3 151.7v27.6C.4 186.9 7 193 15.2 193zm369.9-55H359c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h26.1c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7zM14.9 262h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H14.9C6.7 207 0 213.1 0 220.7v27.6c0 7.6 6.7 13.7 14.9 13.7zm247.4-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.1 14.9-13.7zm136.6 0v-27.6c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7H384c8.3 0 14.9-6.1 14.9-13.7zM82.3 193h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H82.3c-8.2 0-14.9 6.2-14.9 13.7v27.6c.1 7.6 6.7 13.7 14.9 13.7zm138.1 0h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7zm-205.5 0H41c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H14.9C6.7 138 0 144.1 0 151.7v27.6c0 7.6 6.7 13.7 14.9 13.7zm369.9-55h-26.1c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h26.1c8.2 0 14.9-6.2 14.9-13.7v-27.6c-.1-7.6-6.7-13.7-14.9-13.7zm-274 206.9H14.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c-.1-7.5-6.7-13.7-14.9-13.7zm136.6 0h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.5-6.7-13.7-14.9-13.7zm136.6 0h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7H384c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.5-6.6-13.7-14.9-13.7zm-301.7-69c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H82.3zM220.4 331h95.9c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7h-95.9c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.5 6.7 13.7 14.9 13.7zm-205.5 0H41c8.2 0 14.9-6.2 14.9-13.7v-27.6c0-7.6-6.7-13.7-14.9-13.7H14.9C6.7 276 0 282.2 0 289.7v27.6c0 7.5 6.7 13.7 14.9 13.7zm369.9-55.1h-26.1c-8.2 0-14.9 6.2-14.9 13.7v27.6c0 7.6 6.7 13.7 14.9 13.7h26.1c8.2 0 14.9-6.2 14.9-13.7v-27.6c-.1-7.5-6.7-13.7-14.9-13.7z"/%3E%3C/svg%3E');
        }
        ${container} .icon.aisle::before {
            -webkit-mask-image: url('${prefix}path d="M394.9 6.7C389.7-.4 383-.1 378.5.1L24.4.2 22 .1C17.4-.1 10.5-.4 5.1 6.8 2.8 10 0 15.7 0 24.9v357.7c0 9.6 5.6 17.4 12.5 17.4S25 392.2 25 382.6h162.5c0 9.6 5.6 17.4 12.5 17.4s12.5-7.8 12.5-17.4H375c0 9.6 5.6 17.4 12.5 17.4s12.5-7.8 12.5-17.4V24.9c0-9.4-2.8-15.1-5.1-18.2zM187.5 174H25v-52.2h162.5V174zm25-52.2H375V174H212.5v-52.2zM25 208.8h162.5V261H25v-52.2zm187.5 0H375V261H212.5v-52.2zM375 87.1H212.5V34.9H375v52.2zM187.5 34.9v52.2H25V34.9h162.5zM25 347.8v-52.2h162.5v52.2H25zm187.5 0v-52.2H375v52.2H212.5z"/%3E%3C/svg%3E');
        }
        ${container} .icon.start-point::before {
            -webkit-mask-image: url('${prefix}path d="M300 348.6c0 28.4-61.9 51.4-150 51.4S0 377 0 348.6c0-21.1 37-35.4 90-41.4 2.4 3.3 4.9 6.7 7.3 10-40 4.4-67.3 13.8-67.3 24.5 0 15.1 53.7 27.4 120 27.4s120-12.3 120-27.4c0-10.8-27.4-20.1-67.4-24.5l7.3-10c53.1 6 90.1 20.3 90.1 41.4zM400 14v160c0 7.7-7.8 14-17.5 14h-215v146c0 7.7-7.8 14-17.5 14s-17.5-6.3-17.5-14V14c0-7.7 7.8-14 17.5-14h232.5c9.7 0 17.5 6.3 17.5 14zm-97.1 80.1-57.5-41.8V136l57.5-41.9z"/%3E%3C/svg%3E');
        }
        ${container} .icon.zoom-in::before {
            -webkit-mask-image: url('${prefix}path d="m389 336-87.5-87.5-.7-.7c15.4-24.8 24.2-54 24.2-85.3C325 72.9 252.1 0 162.5 0S0 72.9 0 162.5 72.9 325 162.5 325c31.3 0 60.5-8.9 85.3-24.2l.7.7L336 389c7.3 7.3 16.9 11 26.5 11 9.6 0 19.2-3.7 26.5-11 14.7-14.6 14.7-38.4 0-53zM50 162.5C50 100.5 100.5 50 162.5 50S275 100.5 275 162.5 224.5 275 162.5 275 50 224.5 50 162.5zm162.5-25h-25v-25c0-13.8-11.2-25-25-25s-25 11.2-25 25v25h-25c-13.8 0-25 11.2-25 25s11.2 25 25 25h25v25c0 13.8 11.2 25 25 25s25-11.2 25-25v-25h25c13.8 0 25-11.2 25-25s-11.2-25-25-25z"/%3E%3C/svg%3E');
        }
        ${container} .icon.zoom-out::before {
            -webkit-mask-image: url('${prefix}path d="m389 336-87.5-87.5c-.3-.3-.6-.5-.9-.8 15.4-24.8 24.4-54 24.4-85.2C325 72.9 252.1 0 162.5 0S0 72.9 0 162.5 72.9 325 162.5 325c31.3 0 60.4-9 85.2-24.4.3.3.5.6.8.9L336 389c7.3 7.3 16.9 11 26.5 11 9.6 0 19.2-3.7 26.5-11 14.7-14.6 14.7-38.4 0-53zM50 162.5C50 100.5 100.5 50 162.5 50S275 100.5 275 162.5 224.5 275 162.5 275 50 224.5 50 162.5zm162.5-25h-100c-13.8 0-25 11.2-25 25s11.2 25 25 25h100c13.8 0 25-11.2 25-25s-11.2-25-25-25z"/%3E%3C/svg%3E');
        }
        ${container} .icon.apply::before {
            -webkit-mask-image: url('${prefix}path d="m135.858 343.284-130-130c-7.81-7.811-7.81-20.474 0-28.285l28.284-28.284c7.81-7.811 20.474-7.811 28.284 0l87.575 87.573L337.575 56.715c7.81-7.81 20.474-7.81 28.284 0l28.284 28.284c7.81 7.81 7.81 20.474 0 28.285l-230 230c-7.811 7.811-20.474 7.811-28.285 0Z"/%3E%3C/svg%3E');
        }
        ${container} .icon.delete::before {
            -webkit-mask-image: url('${prefix}path d="M50 362.5c0 20.711 16.79 37.5 37.5 37.5h225c20.711 0 37.5-16.789 37.5-37.5V100H50v262.5Zm212.5-200c0-9.622 10.417-15.636 18.75-10.825a12.498 12.498 0 0 1 6.25 10.825v175c0 9.623-10.416 15.637-18.75 10.825a12.5 12.5 0 0 1-6.25-10.825v-175Zm-75 0c0-9.622 10.417-15.636 18.75-10.825a12.498 12.498 0 0 1 6.25 10.825v175c0 9.623-10.416 15.637-18.75 10.825a12.5 12.5 0 0 1-6.25-10.825v-175Zm-75 0c0-9.622 10.417-15.636 18.75-10.825a12.498 12.498 0 0 1 6.25 10.825v175c0 9.623-10.416 15.637-18.75 10.825a12.5 12.5 0 0 1-6.25-10.825v-175ZM362.5 25h-93.75l-7.343-14.609A18.752 18.752 0 0 0 244.61 0h-89.297a18.532 18.532 0 0 0-16.719 10.391L131.25 25H37.5C30.597 25 25 30.597 25 37.5v25C25 69.404 30.597 75 37.5 75h325c6.904 0 12.5-5.596 12.5-12.5v-25c0-6.903-5.596-12.5-12.5-12.5Z"/%3E%3C/svg%3E');
        }
        ${container} .icon.close::before {
            transform: rotate(45deg);
            -webkit-mask-image: url('${prefix}path d="M371.429 157.143H242.857V28.571C242.857 12.794 230.063 0 214.286 0h-28.572c-15.777 0-28.571 12.794-28.571 28.571v128.572H28.571C12.794 157.143 0 169.938 0 185.714v28.572c0 15.776 12.794 28.571 28.571 28.571h128.572v128.571c0 15.776 12.794 28.571 28.571 28.571h28.572c15.776 0 28.571-12.795 28.571-28.571V242.857h128.571c15.776 0 28.571-12.795 28.571-28.571v-28.572c.001-15.776-12.794-28.571-28.57-28.571z"/%3E%3C/svg%3E');
        }
        ${container} .icon.edit::before {
            background-color: #606060;
            background-color: rgb(0, 0, 0, 0.6);
            -webkit-mask-size: 50%;
            -webkit-mask-image: url('${prefix}path d="m388.983 110.961-36.017 36.017a9.382 9.382 0 0 1-13.282 0l-86.722-86.722a9.383 9.383 0 0 1 0-13.281l36.017-36.018c14.61-14.609 38.361-14.609 53.049 0l46.955 46.955c14.688 14.61 14.688 38.361 0 53.049Zm-166.96-33.048L16.859 283.078.296 378.003c-2.266 12.813 8.906 23.907 21.719 21.72l94.926-16.641 205.164-205.165a9.384 9.384 0 0 0 0-13.282l-86.722-86.722c-3.75-3.672-9.688-3.672-13.36 0ZM96.94 265.499a10.894 10.894 0 0 1 0-15.47l120.317-120.317a10.894 10.894 0 0 1 15.47 0 10.894 10.894 0 0 1 0 15.47L112.41 265.499a10.894 10.894 0 0 1-15.47 0Zm-28.204 65.706h37.501v28.36l-50.392 8.829-24.298-24.298 8.828-50.393h28.361v37.502Z"/%3E%3C/svg%3E');
        }
        ${container} .contextmenu hr {
            border: 0;
            margin: 5px 1px;
            border-bottom: 1px solid #dadce0;
        }
        ${container} .contextmenu .menuitem.disabled {
            color: #b9b9b9 !important;
            pointer-events: none;
            background-color: transparent !important;
        }
        ${container} .contextmenu .menuitem:hover {
            background-color: #e8e8e9;
        }
        ${container} dialog[open] {
            display: grid;
        }
        ${container} dialog .resize:hover {
            outline: 1px solid gray;
        }
        ${container} img[src=""], img:not([src]) {
            opacity: 0 !important;
        }`;
        let style = document.createElement('style');
        this._container.appendChild(style);
        style.innerHTML = css;
    }

    _CreateMenu() {
        let menu = document.createElement('div');

        menu.style.width = '100%';
        menu.style.height = LAGER_MAP_MENU_TOP_HEIGHT;
        menu.style.backgroundColor = 'white';
        menu.style.display = 'flex';
        menu.style.alignItems = 'center';
        menu.style.gap = '10px';
        menu.style.padding = '0px 20px';
        menu.style.position = 'relative';
        menu.style.boxShadow = '10px 0 10px 0px rgba(0, 0, 0, 0.5)';

        // Tools
        let menu_tool_cursor = this._menu_tool_cursor = document.createElement('div');
        menu_tool_cursor.style.backgroundColor = '#1b577a';
        menu_tool_cursor.style.height = '34px';
        menu_tool_cursor.style.width = '34px';
        menu_tool_cursor.title = 'Cursor Tool';
        menu_tool_cursor.classList = 'icon cursor toggle active';
        this._AddEventListener(menu_tool_cursor, 'click', (event) => this._EventSelectedTool(event, ToolTypes.CURSOR));
        menu.appendChild(menu_tool_cursor);

        let menu_tool_wall = document.createElement('div');
        menu_tool_wall.style.backgroundColor = '#1b577a';
        menu_tool_wall.style.height = '34px';
        menu_tool_wall.style.width = '34px';
        menu_tool_wall.title = 'Wall Tool';
        menu_tool_wall.classList = 'icon wall toggle';
        this._AddEventListener(menu_tool_wall, 'click', (event) => this._EventSelectedTool(event, ToolTypes.WALL));
        menu.appendChild(menu_tool_wall);

        let menu_tool_pos = document.createElement('div');
        menu_tool_pos.style.backgroundColor = '#1b577a';
        menu_tool_pos.style.height = '34px';
        menu_tool_pos.style.width = '34px';
        menu_tool_pos.title = 'Aisle Tool';
        menu_tool_pos.classList = 'icon aisle position toggle';
        this._AddEventListener(menu_tool_pos, 'click', (event) => this._EventSelectedTool(event, ToolTypes.POSITION));
        menu.appendChild(menu_tool_pos);

        let menu_tool_start = document.createElement('div');
        menu_tool_start.style.backgroundColor = '#1b577a';
        menu_tool_start.style.height = '34px';
        menu_tool_start.style.width = '34px';
        menu_tool_start.title = 'Start Point';
        menu_tool_start.classList = 'icon start-point toggle';
        this._AddEventListener(menu_tool_start, 'click', (event) => this._EventSelectedTool(event, ToolTypes.START));
        menu.appendChild(menu_tool_start);

        let menu_tool_zoom_in = document.createElement('div');
        menu_tool_zoom_in.style.backgroundColor = '#1b577a';
        menu_tool_zoom_in.style.height = '34px';
        menu_tool_zoom_in.style.width = '34px';
        menu_tool_zoom_in.title = 'Zoom In';
        menu_tool_zoom_in.classList = 'icon zoom-in';
        this._AddEventListener(menu_tool_zoom_in, 'click', () => this._EventZoom(LAGER_MAP_WHEEL_ZOOM_STEP));
        menu.appendChild(menu_tool_zoom_in);

        let menu_tool_zoom_out = document.createElement('div');
        menu_tool_zoom_out.style.backgroundColor = '#1b577a';
        menu_tool_zoom_out.style.height = '34px';
        menu_tool_zoom_out.style.width = '34px';
        menu_tool_zoom_out.title = 'Zoom Out';
        menu_tool_zoom_out.classList = 'icon zoom-out';
        this._AddEventListener(menu_tool_zoom_out, 'click', () => this._EventZoom(-LAGER_MAP_WHEEL_ZOOM_STEP));
        menu.appendChild(menu_tool_zoom_out);

        let buttons = [menu_tool_cursor, menu_tool_wall, menu_tool_pos, menu_tool_start, menu_tool_zoom_in, menu_tool_zoom_out];

        for (let button of buttons) for (let event of ['down', 'up']) button['onpointer' + event] = ToggleState;

        this._container.appendChild(menu);

        function ToggleState(event) {
            let target = event.target;
            let pointer = event.type.replace('pointer', '');
            let tool = target.title.split(' ')[0].toLowerCase();
            if (tool == 'zoom') {
                target.classList[pointer == 'down' ? 'add' : 'remove']('active');
                return;
            }
            if (pointer == 'up') {
                target.classList.add('active');
                for (let button of buttons) {
                    if (button != target) {
                        button.classList.remove('active');
                    }
                }
            }
        }
    }

    _CreateContextMenu() {
        let context_menu = document.createElement('div');

        context_menu.style.width = LAGER_MAP_MENU_LEFT_WIDTH;
        context_menu.style.height = `calc(100% - ${LAGER_MAP_MENU_TOP_HEIGHT})`;
        context_menu.style.backgroundColor = '#f1f2f6';
        context_menu.style.display = 'inline-flex';

        let context_menu_border_left = document.createElement('div');
        context_menu_border_left.style.width = '10px';
        context_menu_border_left.style.height = '100%';
        context_menu_border_left.style.boxShadow = 'inset 10px 0 10px -10px rgba(0, 0, 0, 0.5)';
        context_menu_border_left.style.pointerEvents = 'none';
        context_menu.appendChild(context_menu_border_left);

        let context_menu_container = document.createElement('div');
        context_menu_container.style.width = 'calc(100% - 10px)';
        context_menu_container.style.overflow = 'auto';
        context_menu_container.style.height = '100%';
        context_menu.appendChild(context_menu_container);

        this._context_menu = document.createElement('div');
        this._context_menu.id = 'editor-context-menu';
        this._context_menu.style.padding = '30px';
        this._context_menu.style.background = 'white';
        this._context_menu.style.margin = '20px 20px 20px 10px';
        this._context_menu.style.boxShadow = '2px 4px 10px 0 rgb(0, 0, 0, 0.1)';
        context_menu_container.appendChild(this._context_menu);

        this._container.appendChild(context_menu);
    }

    _CreateCanvas() {
        this._canvas_container = document.createElement('div');
        this._canvas_container.style.width = '100%';
        this._canvas_container.style.height = `calc(100% - ${LAGER_MAP_MENU_TOP_HEIGHT})`;
        this._canvas_container.style.display = 'inline-block';
        this._canvas_container.style.overflow = 'scroll';
        this._canvas_container.style.backgroundColor = '#A9A9A9';
        this._canvas_container.style.transition = 'width 0.15s ease-in-out';

        this._canvas = document.createElement('canvas');
        this._canvas.width = LAGER_MAP_CANVAS_WIDTH;
        this._canvas.height = LAGER_MAP_CANVAS_HEIGHT;

        this._offscreen_canvas_wall = document.createElement('canvas');
        this._offscreen_canvas_wall.width = LAGER_MAP_CANVAS_WIDTH;
        this._offscreen_canvas_wall.height = LAGER_MAP_CANVAS_HEIGHT;
        let context_offscreen_canvas_wall = this._offscreen_canvas_wall.getContext('2d');
        context_offscreen_canvas_wall.clearRect(0, 0, this._offscreen_canvas_wall.width, this._offscreen_canvas_wall.height);

        this._offscreen_canvas_pos = document.createElement('canvas');
        this._offscreen_canvas_pos.width = LAGER_MAP_CANVAS_WIDTH;
        this._offscreen_canvas_pos.height = LAGER_MAP_CANVAS_HEIGHT;
        let context_offscreen_canvas_pos = this._offscreen_canvas_pos.getContext('2d');
        context_offscreen_canvas_pos.clearRect(0, 0, this._offscreen_canvas_pos.width, this._offscreen_canvas_pos.height);

        this._offscreen_canvas_gui = document.createElement('canvas');
        this._offscreen_canvas_gui.width = LAGER_MAP_CANVAS_WIDTH;
        this._offscreen_canvas_gui.height = LAGER_MAP_CANVAS_HEIGHT;
        let context_offscreen_canvas_gui = this._offscreen_canvas_gui.getContext('2d');
        context_offscreen_canvas_gui.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        this._offscreen_canvas_background = document.createElement('canvas');
        this._offscreen_canvas_background.width = LAGER_MAP_CANVAS_WIDTH;
        this._offscreen_canvas_background.height = LAGER_MAP_CANVAS_HEIGHT;
        let context_offscreen_canvas_background = this._offscreen_canvas_background.getContext('2d');
        context_offscreen_canvas_background.clearRect(0, 0, this._offscreen_canvas_background.width, this._offscreen_canvas_background.height);
        this._DrawBackground();

        this._offsereen_canvas_start = document.createElement('canvas');
        this._offsereen_canvas_start.width = LAGER_MAP_CANVAS_WIDTH;
        this._offsereen_canvas_start.height = LAGER_MAP_CANVAS_HEIGHT;
        let context_offsereen_canvas_start = this._offsereen_canvas_start.getContext('2d');
        context_offsereen_canvas_start.clearRect(0, 0, this._offsereen_canvas_start.width, this._offsereen_canvas_start.height);

        this._canvas.style.backgroundColor = 'white';

        this._canvas_container.appendChild(this._canvas);
        this._container.appendChild(this._canvas_container);
    }

    _ShowContextMenu(retract_canvas) {
        let width = `calc(100% - ${ LAGER_MAP_MENU_LEFT_WIDTH })`;
        if (retract_canvas === false) width = '100%';
        this._canvas_container.style.width = width;
    }

    _HandleCanvasContextMenu(event) {
        let scale = this._uint_size_m;
        let container = this._canvas_container;
        let textarea = document.createElement('textarea');
        let dialog = document.createElement('dialog');
        let button = document.createElement('button');
        let input = document.createElement('input');
        let span = document.createElement('span');
        let img = document.createElement('img');
        let div = document.createElement('div');
        let hr = document.createElement('hr');
        let contextmenu = div.cloneNode();
        let menuitem = div.cloneNode();
        let modal = div.cloneNode();
        let top = div.cloneNode();
        let apply = button.cloneNode();
        let discard = button.cloneNode();
        contextmenu.className = 'contextmenu';
        menuitem.className = 'menuitem';
        Object.assign(dialog.style, {
            inset: '0',
            zIndex: '1',
            margin: '0',
            padding: '0',
            width: '100%',
            height: '100%',
            border: 'none',
            position: 'fixed',
            //userSelect: 'none',
            placeContent: 'center',
            background: 'rgba(0, 0, 0, 0.4)'
        });
        Object.assign(modal.style, {
            /*width: '50%',
            minWidth: '576px',
            maxWidth: '768px',*/
            padding: '30px',
            background: 'white',
            borderRadius: '10px',
            //overflow: 'hidden',
            color: '#606060',
            position: 'relative'
        });
        Object.assign(contextmenu.style, {
            top: `${event.y}px`,
            left: `${event.x}px`,
            zIndex: '1',
            display: 'flex',
            padding: '3px 0',
            fontSize: '13px',
            position: 'fixed',
            userSelect: 'none',
            flexDirection: 'column',
            backgroundColor: 'white',
            outline: '1px solid #dadce0',
            boxShadow: '5px 5px 3px -2px rgb(0, 0, 0, 0.5)'
        });
        Object.assign(menuitem.style, {
            width: '100%',
            cursor: 'default',
            padding: '4px 38px 3px'
        });
        Object.assign(top.style, {
            display: 'flex',
            marginBottom: '30px',
            flexDirection: 'row'
        });
        for (let button of [apply, discard]) {
            button.className = 'icon';
            Object.assign(button.style, {
                width: '34px',
                height: '34px',
                border: '0',
                outline: '0'
            });
            if (button == apply) {
                button.classList.add('apply');
                Object.assign(button.style, {
                    background: '#58bf5d',
                    marginLeft: 'auto'
                });
            }
            if (button == discard) {
                button.classList.add('close');
                Object.assign(button.style, {
                    marginLeft: '30px',
                    background: '#ff686e'
                });
                button.onclick = () => {
                    removeDialog();
                }
            }
        }
        let set_background_image = menuitem.cloneNode();
        let remove_background_image = menuitem.cloneNode();
        let import_map_data = menuitem.cloneNode();
        let export_map_data = menuitem.cloneNode();
        let reset_map_zoom = menuitem.cloneNode();
        const removeContextmenu = (e) => {
            if (e.target == contextmenu) return;
            if (contextmenu.contains(e.target)) return;
            if (!container.contains(contextmenu)) return;
            window.removeEventListener('pointerdown', removeContextmenu);
            contextmenu.remove();
        }
        const removeDialog = () => {
            //if (e && ![dialog].includes(e.target)) return;
            window.removeEventListener('pointerdown', removeDialog);
            dialog.remove();
        }
        set_background_image.textContent = 'Set background image';
        remove_background_image.textContent = 'Remove background image';
        import_map_data.textContent = 'Import map data';
        export_map_data.textContent = 'Export map data';
        reset_map_zoom.textContent = 'Reset map zoom';
        if (!this._canvas_background_image) {
            remove_background_image.classList.add('disabled');
        }
        if (this._data_init == this.Serialize()) {
            export_map_data.classList.add('disabled');
        }
        if (this._scale == 1) {
            reset_map_zoom.classList.add('disabled');
        }
        set_background_image.onclick = () => {
            let area = div.cloneNode();
            let wrapper = div.cloneNode();
            let resizer = div.cloneNode();
            let mover = div.cloneNode();
            let grid = img.cloneNode();
            let background = img.cloneNode();
            let upload = input.cloneNode();
            let file = input.cloneNode();
            let opacity = input.cloneNode();
            let opacity_label = div.cloneNode();
            let opacity_label_text = span.cloneNode();
            let opacity_label_value = span.cloneNode();
            //let placeholder = 'data:image/svg+xml,%3Csvg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M362.5 350h-325C16.789 350 0 333.211 0 312.5v-225C0 66.789 16.789 50 37.5 50h325c20.711 0 37.5 16.789 37.5 37.5v225c0 20.711-16.789 37.5-37.5 37.5ZM87.5 93.75c-24.163 0-43.75 19.587-43.75 43.75 0 24.162 19.587 43.75 43.75 43.75 24.162 0 43.75-19.588 43.75-43.75 0-24.163-19.588-43.75-43.75-43.75ZM50 300h300v-87.5l-68.371-68.371c-3.661-3.661-9.597-3.661-13.259 0L162.5 250l-43.371-43.371c-3.661-3.661-9.597-3.661-13.259 0L50 262.5V300Z"/%3E%3C/svg%3E';
            const drag = {
                item: mover,
                active: false,
                pointer: {
                    down: (e) => {
                        drag.x.initial = e.clientX - drag.x.offset;
                        drag.y.initial = e.clientY - drag.y.offset;
                        if (e.target == drag.item && !e.button) {
                            resizer.style.cursor = 'grabbing';
                            drag.active = true;
                        }
                    },
                    move: (e) => {
                        if (!drag.active) return;
                        e.preventDefault();
                        drag.x.current = e.clientX - drag.x.initial;
                        drag.y.current = e.clientY - drag.y.initial;
                        drag.x.offset = drag.x.current;
                        drag.y.offset = drag.y.current;
                        drag.translate(drag.x.offset, drag.y.offset);
                    },
                    up: () => {
                        drag.x.initial = drag.x.current;
                        drag.y.initial = drag.y.current;
                        resizer.style.cursor = 'grab';
                        drag.active = false;
                    }
                },
                event: {
                    mount: () => drag.event.state(true),
                    unmount: () => drag.event.state(false),
                    state: (mount) => {
                        if (mount && drag.event.state.mounted) return;
                        drag.event.state.mounted = mount;
                        for (let event in drag.pointer) {
                            window[(mount ? 'add' : 'remove') + 'EventListener']('pointer' + event, drag.pointer[event], false);
                        }
                    }
                },
                reset: () => {
                    Object.assign(drag, {x: {initial: 0, current: 0, offset: 0}, y: {initial: 0, current: 0, offset: 0}});
                    drag.translate(drag.x.offset, drag.y.offset);
                },
                translate: (x, y) => {
                    resizer.style.transform = `translate(${x}px, ${y}px)`;
                }
            };
            top.className = 'label';
            for (let input of [file, upload]) {
                input.type = 'file';
                input.accept = '.jpg, .jpeg, .png';
                input.title = '';
                if (input == file) {
                    input.classList.add('v-input');
                    input.style.marginRight = '30px';
                }
                input.onchange = (e) => {
                    let files = e.target.files;
                    let reader = new FileReader();
                    if (!files.length) {
                        //background.src = placeholder;
                        return;
                    }
                    reader.onload = () => {
                        area.scrollTop = 0;
                        grid.src = this._canvas_grid;
                        background.onload = () => {
                            Object.assign(resizer.style, {
                                width: parseInt(background.naturalWidth * grid.scale) + 'px',
                                height: parseInt(background.naturalHeight * grid.scale) + 'px'
                            });
                            drag.reset();
                            drag.event.mount();
                        }
                        background.src = reader.result;
                    }
                    reader.readAsDataURL(files[0]);
                }
            }
            opacity_label.className = 'label';
            opacity_label_text.textContent = 'Opacity';
            opacity_label_value.textContent = '40%';
            opacity.type = 'range';
            opacity.setAttribute('value', '0.4');
            opacity.step = '0.01';
            opacity.min = '0';
            opacity.max = '1';
            Object.assign(opacity_label.style, {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                margin: '0 auto 0 30px'
            });
            Object.assign(opacity.style, {
                outline: '0',
                margin: '0 10px'
            });
            opacity.oninput = () => {
                background.style.opacity = opacity.value;
                opacity_label_value.textContent = (parseFloat(opacity.value) * 100).toFixed(0) + '%';
            }
            apply.onclick = () => {
                const rect = {grid, background};
                for (let img in rect) rect[img] = rect[img].getBoundingClientRect();
                let top = ((rect.background.top - rect.grid.top) / grid.scale) * scale;
                let left = ((rect.background.left - rect.grid.left) / grid.scale) * scale;
                let width = (rect.background.width / grid.scale) * scale;
                let height = (rect.background.height / grid.scale) * scale;
                this.SetBackground(background, width, height, left, top, opacity.value);
                this._canvas_background_image = background;
                drag.event.unmount();
                removeDialog();
            }
            discard.onclick = () => {
                drag.event.unmount();
                removeDialog();
            }
            for (let item of [grid, resizer, mover, background]) {
                if (item == background) {
                    Object.assign(item.style, {
                        width: '100%',
                        height: '100%',
                        opacity: opacity.value,
                        position: 'relative',
                        objectFit: 'contain',
                        pointerEvents: 'none'
                    });
                } else {
                    Object.assign(item.style, {
                        top: '0',
                        left: '0',
                        position: 'absolute'
                    });
                }
                if (item == grid) {
                    Object.assign(item.style, {
                        width: '100%',
                        height: 'auto',
                        pointerEvents: 'none',
                        backgroundColor: '#ffffff'
                    });
                    item.onload = () => {
                        let rect = grid.getBoundingClientRect();
                        wrapper.style.height = rect.height + 'px';
                        grid.scale = (rect.width / this._canvas.width) * this._scale;
                    }
                    //item.src = this._canvas.toDataURL();
                    item.src = this._canvas_grid;
                }
                if (item == resizer) {
                    item.draggable = false;
                    item.className = 'resize';
                    Object.assign(item.style, {
                        cursor: 'grab',
                        resize: 'horizontal',
                        overflow: 'hidden'
                    });
                    /*
                    item.onmouseenter = () => {
                        item.style.setProperty('resize', 'horizontal');
                    }
                    item.onmouseleave = () => {
                        item.style.removeProperty('resize');
                    }
                    */
                    (new ResizeObserver(() => {
                        let rect = background.getBoundingClientRect();
                        item.style.height = parseInt(rect.height) + 'px';
                    })).observe(item);
                }
            }
            Object.assign(area.style, {
                width: '800px',
                height: '450px',
                position: 'relative',
                overflow: 'auto',
                userSelect: 'none',
                backgroundColor: '#a9a9a9',
                border: '1px solid rgb(169, 169, 169)'
            });
            Object.assign(wrapper.style, {
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                position: 'relative'
            });
            Object.assign(upload.style, {
                zIndex: '1',
                inset: '0',
                border: '0',
                outline: '0',
                opacity: '0',
                cursor: 'pointer',
                position: 'absolute'
            });
            /*
            area.oncontextmenu = (e) => {
                e.preventDefault();
                return false;
            }
            */
            opacity_label.append(opacity_label_text, opacity, opacity_label_value);
            top.append(file, opacity_label, apply, discard);
            mover.appendChild(background);
            resizer.appendChild(mover);
            wrapper.appendChild(resizer, /*upload*/);
            area.append(grid, wrapper);
            modal.append(top, area);
            container.appendChild(dialog);
            contextmenu.remove();
            dialog.show();
        }
        remove_background_image.onclick = () => {
            this._canvas_background_image = null;
            this._DrawBackground();
            this._DrawCanvas();
            contextmenu.remove();
        }
        import_map_data.onclick = () => {
            let heading = div.cloneNode();
            let label = div.cloneNode();
            let area = textarea.cloneNode();
            const isJSON = (string) => {
                try {
                    JSON.parse(string);
                } catch (e) {
                    return false;
                }
                return true;
            }
            const unescapeJSON = (string) => {
                if (!isJSON(string)) return;
                let json = JSON.parse(string);
                if (typeof json == 'string') {
                    json = JSON.parse(json);
                }
                return json;
            }
            heading.textContent = 'Import map data';
            label.className = 'label';
            area.className = 'v-textarea';
            area.placeholder = 'Insert JSON string here...';
            area.spellcheck = false;
            Object.assign(heading.style, {
                fontSize: '1.222rem',
                fontWeight: '600'
            });
            Object.assign(area.style, {
                width: '800px',
                height: '450px',
                minWidth: '300px',
                minHeight: '150px',
                maxWidth: 'calc(100vw - 60px)',
                maxHeight: 'calc(100vh - 124px)'
            });
            area.onpaste = () => {
                setTimeout(() => {
                    let json = unescapeJSON(area.value);
                    if (!json) {
                        /*
                        this._Message(
                            'Import error',
                            'Invalid JSON string'
                        );
                        */
                        return;
                    }
                    area.value = JSON.stringify(json);
                });
            }
            area.onchange = () => {
                let json = unescapeJSON(area.value);
                //area.value = JSON.stringify(json, null, 2);
                if (!json) return;
                area.value = JSON.stringify(json);
            }
            apply.onclick = () => {
                let json = unescapeJSON(area.value);
                let data = JSON.stringify(json);
                if (!isJSON(data)) {
                    this._Message(
                        'Import error',
                        'Invalid JSON string'
                    );
                    area.focus();
                    return;
                }
                this.Deserialize(data);
                removeDialog();
            }
            label.appendChild(area);
            top.append(heading, apply, discard);
            modal.append(top, label);
            container.appendChild(dialog);
            contextmenu.remove();
            dialog.show();
            area.focus();
        }
        export_map_data.onclick = () => {
            let heading = div.cloneNode();
            let label = div.cloneNode();
            let area = textarea.cloneNode();
            area.readOnly = true;
            discard.style.marginLeft = 'auto';
            heading.textContent = 'Export map data';
            label.className = 'label';
            area.className = 'v-textarea';
            area.spellcheck = false;
            Object.assign(heading.style, {
                fontSize: '1.222rem',
                fontWeight: '600'
            });
            Object.assign(area.style, {
                width: '800px',
                height: '450px',
                minWidth: '300px',
                minHeight: '150px',
                maxWidth: 'calc(100vw - 60px)',
                maxHeight: 'calc(100vh - 124px)'
            });
            area.value = this.Serialize();
            label.appendChild(area);
            top.append(heading, discard);
            modal.append(top, label);
            container.appendChild(dialog);
            contextmenu.remove();
            dialog.show();
            area.focus();
            area.select();
        }
        reset_map_zoom.onclick = () => {
            this._DrawCanvas(1);
            contextmenu.remove();
        }
        window.addEventListener('pointerdown', removeDialog);
        window.addEventListener('pointerdown', removeContextmenu);
        container.onscroll = (e) => removeContextmenu(e);
        contextmenu.oncontextmenu = (e) => {
            e.preventDefault();
            e.target.click();
            return false;
        }
        contextmenu.append(set_background_image, remove_background_image, hr.cloneNode(), import_map_data, export_map_data, hr.cloneNode(), reset_map_zoom);
        container.appendChild(contextmenu);
        this._menu_tool_cursor.click();
        dialog.appendChild(modal);
    }

    _CreateEventListener() {
        this._AddEventListener(this._canvas, 'mousedown', (event) => this._EventMouseDown(event));
        this._AddEventListener(this._canvas, 'mouseup', (event) => this._EventMouseUp(event));
        this._AddEventListener(this._canvas, 'mousemove', (event) => this._EventMouseMove(event));
        this._AddEventListener(this._canvas, 'wheel', (event) => this._EventWheel(event));
        this._AddEventListener(this._canvas, 'contextmenu', (event) => { 
            event.preventDefault();
            this._HandleCanvasContextMenu(event);
            return false;
        }, false);
        //this._AddEventListener(document.querySelector('html'), 'mouseleave', (event) => this._EventSelectedTool(event, this._selected_tool));
        this._AddEventListener(window, 'resize', () => this._DrawCanvas());
    }

    _CreatePopupEditRacks() {
        this._dialog = document.createElement('dialog');
        this._dialog.style.padding = '10vh 0';
        this._dialog.style.border = '0px';
        this._dialog.style.margin = '0px';
        this._dialog.style.zIndex = '1';
        this._dialog.style.width = '100%';
        this._dialog.style.height = '100%';
        this._dialog.style.maxWidth = '100%';
        this._dialog.style.borderRadius = '0px';
        this._dialog.style.maxBlockSize = '100vh';
        this._dialog.style.alignContent = 'center';
        this._dialog.style.justifyContent = 'center';
        this._dialog.style.background = 'rgba(0, 0, 0, 0.4)';
        this._container.appendChild(this._dialog);
    }

    //***************************************************
    // Events
    //***************************************************

    _EventMouseDown(event) {
        if (event.button != 0) return;

        this._selected_node = {
            'event': event,
            'canvas_cursor_position': this._CanvasCursorPosition(event),
        };

        switch (this._selected_tool) {
            case ToolTypes.CURSOR: {
                this._EventMouseDown__NodeDetect(event);
                this._EventMouseMove(event);
                break;
            }

            case ToolTypes.POSITION:
                this._EventMouseDown__Position(event);
                break;

            case ToolTypes.START:
                this._EventMouseDown__Start(event)
                break;

            default:
                break;
        }

        // console.debug('_EventMouseDown', this._selected_node.canvas_cursor_position);
    }

    _EventMouseUp(event) {
        if (event.button != 0) return;

        let args = {
            'event': event,
            'canvas_cursor_position': this._CanvasCursorPosition(event),
        };

        switch (this._selected_tool) {
            case ToolTypes.WALL:
                if (this._selected_node) {
                    this._EventMouseUp_WallCreate(args);
                }
                break;

            case ToolTypes.CURSOR:
                if (this._selected_node?.cursor?.id) {
                    this._selected_context = this._selected_node.cursor;
                    this._EventMouseUp_Cursor(args)
                }

                this._UpdateSelectedContext();
                break;

            default:
                break;
        }

        // console.debug('_EventMouseUp', args.canvas_cursor_position);
    }

    _EventMouseMove(event) {
        // console.debug('_EventMouseMove', event);
        let args = {
            'event': event,
            'canvas_cursor_position': this._CanvasCursorPosition(event),
        };

        switch (this._selected_tool) {
            case ToolTypes.WALL:
                if (this._selected_node) { // create wall
                    this._EventMouseMove__WallCreate(args);
                }
                break;

            case ToolTypes.CURSOR:
                if (this._selected_node?.cursor?.id) {  // Node is selected
                    this._EventMouseMove__Cursor(args);
                }
                break

            case ToolTypes.POSITION:
                this._EventMouseMove__Position(args);
                break;

            default:
                break;
        }
    }

    _EventWheel(event) {
        if (event.ctrlKey) {
            event.preventDefault();

            if (event.deltaY == 0) return;

            if (event.deltaY > 0) {
                this._EventZoom(-LAGER_MAP_WHEEL_ZOOM_STEP);
            } else {
                this._EventZoom(LAGER_MAP_WHEEL_ZOOM_STEP);
            }
        }

    }

    _EventSelectedTool(event, tool) {
        // console.debug('_EventSelectedTool:', tool, event);
        this._selected_tool = tool;
        this._selected_node = null;
        this._selected_context = null;

        this._UpdateSelectedContext();

        let context = this._offscreen_canvas_gui.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        this._canvas.style.cursor = /wall|start/.test(tool?.toString() || '') ? 'crosshair' : 'default';

        if (tool == ToolTypes.CURSOR) window.removeEventListener('keydown', this._DeleteSelectedEntry);

        this._DrawWall();
        this._DrawPos();
        this._DrawCanvas();
    }

    //***************************************************
    // Event subroutines
    //***************************************************

    _EventMouseMove__WallCreate(args) {
        let line_to = this._SnapLineTo45DegreeAngle(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            args.canvas_cursor_position.x,
            args.canvas_cursor_position.y,
            this._offscreen_canvas_gui.width,
            this._offscreen_canvas_gui.height
        );

        let d = this._Round(this._uint_size_m * this._DistanceBetweenTwoPoints(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            line_to.x,
            line_to.y,
        ), LAGER_MAP_DECIMAL_PLACES);

        let context = this._offscreen_canvas_gui.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);
        context.beginPath();
        context.lineWidth = LAGER_MAP_WALL_WIDTH;
        context.moveTo(this._selected_node.canvas_cursor_position.x, this._selected_node.canvas_cursor_position.y);
        context.lineTo(line_to.x, line_to.y);
        context.stroke();
        context.beginPath();
        //context.font = `${20 * (1 / this._scale)}px ${LAGER_MAP_FONT}`;
        //context.fillText(`${d.toFixed(LAGER_MAP_DECIMAL_PLACES)}m`, line_to.x + 20, line_to.y);
        context.font = `${LAGER_MAP_REOL_FONT_WEIGHT} ${LAGER_MAP_REOL_FONT_SIZE}px ${LAGER_MAP_FONT}`;
        context.fillText(`${d.toFixed(LAGER_MAP_DECIMAL_PLACES)}m`, LAGER_MAP_REOL_FONT_SIZE + line_to.x, line_to.y);
        
        this._DrawCanvas();
    }

    _EventMouseUp_WallCreate(args) {
        let d = Math.abs(Math.sqrt(
            Math.pow(this._selected_node.canvas_cursor_position.x - args.canvas_cursor_position.x, 2)
          + Math.pow(this._selected_node.canvas_cursor_position.y - args.canvas_cursor_position.y, 2)
        ));

        if (d <= 4) {
            this._selected_node = null;
            this._DrawCanvas();
            return;
        }

        let line_to = this._SnapLineTo45DegreeAngle(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            args.canvas_cursor_position.x,
            args.canvas_cursor_position.y,
            this._offscreen_canvas_gui.width,
            this._offscreen_canvas_gui.height,
        );

        let new_wall = this._AddEntryWall(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            line_to.x,
            line_to.y,
        );

        let context = this._offscreen_canvas_wall.getContext('2d');
        context.lineWidth = LAGER_MAP_WALL_WIDTH;

        context.beginPath();
        context.moveTo(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
        );
        context.lineTo(line_to.x, line_to.y);
        context.stroke();

        context.beginPath();
        context.arc(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            LAGER_MAP_WALL_END_SIZE,
            0,
            2 * Math.PI,
        );
        context.fillStyle = "#000000";
        context.fill();
        context.stroke();

        context.beginPath();
        context.arc(line_to.x, line_to.y, LAGER_MAP_WALL_END_SIZE, 0, 2 * Math.PI);
        context.fillStyle = "#000000";
        context.fill();
        context.stroke();

        this._selected_node = null;

        this._selected_context = { 'opcode': 1, 'id': new_wall.id };
        this._UpdateSelectedContext();
        
        this._DrawSelected();
        this._DrawCanvas();
    }

    _EventZoom(delta_zoom) {
        let new_zoom_factor = this._scale + delta_zoom;
        // console.debug(new_zoom_factor);
        if (new_zoom_factor >= LAGER_MAP_MIN_ZOOM && new_zoom_factor <= LAGER_MAP_MAX_ZOOM) {
            this._DrawCanvas(new_zoom_factor);
        }
    }

    _EventMouseDown__NodeDetect() {
        let id_canvas = document.createElement('canvas');
        id_canvas.style.imageRendering = 'pixelated';
        id_canvas.height = LAGER_MAP_CANVAS_HEIGHT;
        id_canvas.width = LAGER_MAP_CANVAS_WIDTH;

        let id_context = id_canvas.getContext('2d');

        id_context.clearRect(0, 0, id_canvas.width, id_canvas.height);
        id_context.fillStyle = "#FFFFFFFF";
        id_context.fillRect(0, 0, id_canvas.width, id_canvas.height);

        id_context.fillStyle = "#00000000";

        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let entity = this._entities[ids[i]];
            if (entity?.id == null) continue;

            let color_id = '#' + (entity.id).toString(16).padStart(6, '0') + 'FF';

            switch (entity.type) {
                case EntitieTypes.WALL:
                    this._EventMouseDown__NodeDetect__Wall(id_context, color_id, entity);
                    break;

                case EntitieTypes.POSITION:
                    this._EventMouseDown__NodeDetect__Pos(id_context, color_id, entity);
                    break;

                default:
                    break;
            }
        }

        let data = id_context.getImageData(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            1,
            1,
        ).data;

        let event_target = data[0].toString(16).padStart(2, '0')
                         + data[1].toString(16).padStart(2, '0')
                         + data[2].toString(16).padStart(2, '0');

        let opcode = parseInt(event_target.slice(0, 1), 16);
        this._selected_node.cursor = {
            'opcode': opcode,
            'id': opcode == 15 ? null : parseInt(event_target.slice(1), 16),
        };

        if (this._selected_tool == ToolTypes.CURSOR) {
            if (this._selected_node.cursor.id == null) {
                this._menu_tool_cursor.click();
            }
        }
        
        this._DrawPos();
        this._DrawWall();
        this._DrawCanvas();

        // console.debug(
        //     '_EventClick__MoveNodeDetect',
        //     this._selected_node.canvas_cursor_position.x,
        //     this._selected_node.canvas_cursor_position.y,
        //     '=>',
        //     `#${event_target}ff`,
        //     this._selected_node.cursor,
        // );
        // let c = this._canvas.getContext('2d');
        // c.drawImage(id_canvas, 0, 0, this._canvas.width, this._canvas.height);
    }

    _EventMouseDown__Position(event) {
        event.preventDefault();

        let new_pos = this._AddEntryPos(
            this._selected_node.canvas_cursor_position.x,
            this._selected_node.canvas_cursor_position.y,
            this._context_menu_pos_input.length,
            this._context_menu_pos_input.width,
            this._context_menu_pos_input.angle,
            this._context_menu_pos_input.aisle,
            this._context_menu_pos_input.racks,
        );

        this._DrawPos();
        this._DrawCanvas();
        
        this._selected_tool = ToolTypes.CURSOR;
        this._selected_context = { 'opcode': 1, 'id': new_pos.id };
        this._UpdateSelectedContext();
    }

    _EventMouseDown__Start(event) {
        event.preventDefault();

        let start_node = null;

        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let offset = ids[i];
            if (this._entities[offset]?.type == EntitieTypes.START) {
                start_node = this._entities[offset];
                break;
            }
        }

        if (!start_node) {
            let id = this._NextEntryId();
            this._entities[id] = {
                'id': id,
                'type': EntitieTypes.START,
                'x': this._selected_node.canvas_cursor_position.x,
                'y': this._selected_node.canvas_cursor_position.y,
                'args': null,
            };
        } else {
            start_node.x = this._selected_node.canvas_cursor_position.x;
            start_node.y = this._selected_node.canvas_cursor_position.y;
        }

        this._DrawStart();
        this._DrawCanvas();
    }

    _EventMouseMove__Cursor(args) {
        let context = this._offscreen_canvas_gui.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        let selected_entitiy = this._entities[this._selected_node.cursor.id];
        let from_x, from_y;

        switch (selected_entitiy.type) {
            case EntitieTypes.WALL: {
                if (this._selected_node.cursor.opcode == 1) {
                    from_x = selected_entitiy.args.to.x;
                    from_y = selected_entitiy.args.to.y;
                } else {
                    from_x = selected_entitiy.x;
                    from_y = selected_entitiy.y;
                }

                let line_to = this._SnapLineTo45DegreeAngle(
                    from_x,
                    from_y,
                    args.canvas_cursor_position.x,
                    args.canvas_cursor_position.y,
                    this._offscreen_canvas_gui.width,
                    this._offscreen_canvas_gui.height
                );

                context.beginPath();
                context.lineWidth = LAGER_MAP_WALL_WIDTH;
                context.moveTo(from_x, from_y);
                context.lineTo(line_to.x, line_to.y);
                context.stroke();

                context.beginPath();
                context.arc(from_x, from_y, LAGER_MAP_WALL_END_SIZE, 0, 2 * Math.PI);
                context.fillStyle = "#000000";
                context.fill();
                context.stroke();

                context.beginPath();
                context.arc(line_to.x, line_to.y, LAGER_MAP_WALL_END_SIZE, 0, 2 * Math.PI);
                context.fillStyle = "#000000";
                context.fill();
                context.stroke();

                let d = this._Round(this._uint_size_m * this._DistanceBetweenTwoPoints(
                    from_x,
                    from_y,
                    line_to.x,
                    line_to.y,
                ), LAGER_MAP_DECIMAL_PLACES);

                context.beginPath();
                //context.font = `${20 * (1 / this._scale)}px ${LAGER_MAP_FONT}`;
                //context.fillText(`${d.toFixed(LAGER_MAP_DECIMAL_PLACES)}m`, line_to.x + 20, line_to.y);
                context.font = `${LAGER_MAP_REOL_FONT_WEIGHT} ${LAGER_MAP_REOL_FONT_SIZE}px ${LAGER_MAP_FONT}`;
                context.fillText(`${d.toFixed(LAGER_MAP_DECIMAL_PLACES)}m`, LAGER_MAP_REOL_FONT_SIZE + line_to.x, line_to.y);

                break;
            }
            case EntitieTypes.POSITION: {
                let delta_width = selected_entitiy.args.width / this._uint_size_m;
                let delta_height = selected_entitiy.args.length / this._uint_size_m;

                let offset_width = delta_width / 2;
                let offset_height = delta_height / 2;

                let cosθ = Math.cos(selected_entitiy.args.angle * (Math.PI / 180));
                let sinθ = Math.sin(selected_entitiy.args.angle * (Math.PI / 180));

                // Box
                let x_0 = -offset_width;
                let y_0 = -offset_height;

                let x_1 = delta_width - offset_width;
                let y_1 = -offset_height;

                let x_2 = delta_width - offset_width;
                let y_2 = delta_height - offset_height;

                let x_3 = -offset_width;
                let y_3 = delta_height - offset_height;

                // X_new = X_old x cos_θ – Y_old * sin_θ
                // Y_new = X_old x sin_θ + Y_old * cos_θ

                let x_offset = args.canvas_cursor_position.x + (selected_entitiy.x - this._selected_node.canvas_cursor_position.x);
                let y_offset = args.canvas_cursor_position.y + (selected_entitiy.y - this._selected_node.canvas_cursor_position.y);

                let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + x_offset;
                let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + y_offset;

                let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + x_offset;
                let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + y_offset;

                let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + x_offset;
                let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + y_offset;

                let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + x_offset;
                let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + y_offset;

                context.lineWidth = LAGER_MAP_WALL_WIDTH;
                context.lineStyle = LAGER_MAP_REOL_LINE_STYLE;
                context.fillStyle = LAGER_MAP_REOL_FILL_STYLE;

                context.beginPath();
                context.moveTo(x_0_θ, y_0_θ);
                context.lineTo(x_1_θ, y_1_θ);
                context.lineTo(x_2_θ, y_2_θ);
                context.lineTo(x_3_θ, y_3_θ);
                context.lineTo(x_0_θ, y_0_θ);
                context.closePath();

                context.stroke();
                context.fill();

                context.save();
                if (selected_entitiy.args.angle < 90)  {
                    context.translate(x_0_θ, y_0_θ);
                } else if (selected_entitiy.args.angle < 270) {
                    context.translate(x_3_θ, y_3_θ);
                } else {
                    context.translate(x_0_θ, y_0_θ);
                }

                context.rotate(-Math.PI / 4);
                context.fillStyle = !selected_entitiy.args.aisle ? LAGER_MAP_REOL_FILL_STYLE : '#000000';
                context.font = `${LAGER_MAP_REOL_FONT_WEIGHT} ${LAGER_MAP_REOL_FONT_SIZE}px ${LAGER_MAP_FONT}`;
                context.fillText(selected_entitiy.args.aisle ? selected_entitiy.args.aisle : '{NOT SET}', 10, 0);
                context.restore();

                // Separate and gate
                context.fillStyle = LAGER_MAP_REOL_GATE_FILL_STYLE;

                let separate_gap = selected_entitiy.args.length / this._uint_size_m / selected_entitiy.args.racks;
                let separate_gap_half = separate_gap / 2;
                for (let i = 0; i < selected_entitiy.args.racks; i++) {
                    let separate_x_0 = -offset_width;
                    let separate_y_0 = -offset_height + (separate_gap * i);
                    let separate_x_1 = offset_width;
                    let separate_y_1 = separate_y_0;

                    let separate_x_0_θ = (separate_x_0 * cosθ) - (separate_y_0 * sinθ) + x_offset;
                    let separate_y_0_θ = (separate_x_0 * sinθ) + (separate_y_0 * cosθ) + y_offset;

                    let separate_x_1_θ = (separate_x_1 * cosθ) - (separate_y_1 * sinθ) + x_offset;
                    let separate_y_1_θ = (separate_x_1 * sinθ) + (separate_y_1 * cosθ) + y_offset;
                    
                    if (i != 0) {
                        context.beginPath();
                        context.moveTo(separate_x_0_θ, separate_y_0_θ);
                        context.lineTo(separate_x_1_θ, separate_y_1_θ);
                        context.stroke();
                    }

                    let separate_gate_x_θ = (separate_x_0 * cosθ) - ((separate_y_0 + separate_gap_half) * sinθ) + x_offset;
                    let separate_gate_y_θ = (separate_x_0 * sinθ) + ((separate_y_0 + separate_gap_half) * cosθ) + y_offset;

                    context.beginPath();
                    context.arc(separate_gate_x_θ, separate_gate_y_θ, LAGER_MAP_REOL_GATE_SIZE, 0, Math.PI * 2);
                    context.fill();
                    context.stroke();
                }
                break;
            }

            default:
                break;
        }

        this._DrawCanvas();
    }

    _EventMouseMove__Position(args) {
        let context = this._offscreen_canvas_gui.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        let delta_width = this._context_menu_pos_input.width / this._uint_size_m;
        let delta_height = this._context_menu_pos_input.length / this._uint_size_m;

        let offset_width = delta_width / 2;
        let offset_height = delta_height / 2;

        let cosθ = Math.cos(this._context_menu_pos_input.angle * (Math.PI / 180));
        let sinθ = Math.sin(this._context_menu_pos_input.angle * (Math.PI / 180));

        // Box
        let x_0 = -offset_width;
        let y_0 = -offset_height;

        let x_1 = delta_width - offset_width;
        let y_1 = -offset_height;

        let x_2 = delta_width - offset_width;
        let y_2 = delta_height - offset_height;

        let x_3 = -offset_width;
        let y_3 = delta_height - offset_height;

        // X_new = X_old x cos_θ – Y_old * sin_θ
        // Y_new = X_old x sin_θ + Y_old * cos_θ

        let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + args.canvas_cursor_position.x;
        let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + args.canvas_cursor_position.y;

        let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + args.canvas_cursor_position.x;
        let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + args.canvas_cursor_position.y;

        let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + args.canvas_cursor_position.x;
        let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + args.canvas_cursor_position.y;

        let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + args.canvas_cursor_position.x;
        let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + args.canvas_cursor_position.y;

        context.lineWidth = LAGER_MAP_WALL_WIDTH;
        context.lineStyle = LAGER_MAP_REOL_LINE_STYLE;
        context.fillStyle = LAGER_MAP_REOL_FILL_STYLE;

        context.beginPath();
        context.moveTo(x_0_θ, y_0_θ);
        context.lineTo(x_1_θ, y_1_θ);
        context.lineTo(x_2_θ, y_2_θ);
        context.lineTo(x_3_θ, y_3_θ);
        context.lineTo(x_0_θ, y_0_θ);
        context.closePath();

        context.stroke();
        context.fill();

        // Separate and gate
        context.fillStyle = LAGER_MAP_REOL_GATE_FILL_STYLE;

        let separate_gap = this._context_menu_pos_input.length / this._uint_size_m / this._context_menu_pos_input.racks;
        let separate_gap_half = separate_gap / 2;
        for (let i = 0; i < this._context_menu_pos_input.racks; i++) {
            let separate_x_0 = -offset_width;
            let separate_y_0 = -offset_height + (separate_gap * i);
            let separate_x_1 = offset_width;
            let separate_y_1 = separate_y_0;

            let separate_x_0_θ = (separate_x_0 * cosθ) - (separate_y_0 * sinθ) + args.canvas_cursor_position.x;
            let separate_y_0_θ = (separate_x_0 * sinθ) + (separate_y_0 * cosθ) + args.canvas_cursor_position.y;

            let separate_x_1_θ = (separate_x_1 * cosθ) - (separate_y_1 * sinθ) + args.canvas_cursor_position.x;
            let separate_y_1_θ = (separate_x_1 * sinθ) + (separate_y_1 * cosθ) + args.canvas_cursor_position.y;

            if (i != 0) {
                context.beginPath();
                context.moveTo(separate_x_0_θ, separate_y_0_θ);
                context.lineTo(separate_x_1_θ, separate_y_1_θ);
                context.stroke();
            }

            let separate_gate_x_θ = (separate_x_0 * cosθ) - ((separate_y_0 + separate_gap_half) * sinθ) + args.canvas_cursor_position.x;
            let separate_gate_y_θ = (separate_x_0 * sinθ) + ((separate_y_0 + separate_gap_half) * cosθ) + args.canvas_cursor_position.y;

            context.beginPath();
            context.arc(separate_gate_x_θ, separate_gate_y_θ, LAGER_MAP_REOL_GATE_SIZE, 0, Math.PI * 2);
            context.fill();
            context.stroke();
        }

        this._DrawCanvas();
    }

    _EventMouseUp_Cursor(args) {
        let context = this._offscreen_canvas_gui.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        let selected_entitiy = this._entities[this._selected_node.cursor.id];
        let from_x, from_y;

        switch (selected_entitiy?.type) {
            case EntitieTypes.WALL: {
                let wall_mouse_distance_deleta;
                if (this._selected_node.cursor.opcode == 1) {
                    wall_mouse_distance_deleta = this._DistanceBetweenTwoPoints(
                        selected_entitiy.x,
                        selected_entitiy.y,
                        args.canvas_cursor_position.x,
                        args.canvas_cursor_position.y,
                    );

                    from_x = selected_entitiy.args.to.x;
                    from_y = selected_entitiy.args.to.y;
                } else {
                    wall_mouse_distance_deleta = this._DistanceBetweenTwoPoints(
                        selected_entitiy.args.to.x,
                        selected_entitiy.args.to.y,
                        args.canvas_cursor_position.x,
                        args.canvas_cursor_position.y,
                    );

                    from_x = selected_entitiy.x;
                    from_y = selected_entitiy.y;
                }

                if (wall_mouse_distance_deleta > LAGER_MAP_WALL_DEADZONE) {
                    let line_to = this._SnapLineTo45DegreeAngle(
                        from_x,
                        from_y,
                        args.canvas_cursor_position.x,
                        args.canvas_cursor_position.y,
                        this._offscreen_canvas_gui.width,
                        this._offscreen_canvas_gui.height
                    );

                    if (this._selected_node.cursor.opcode == 1) {
                        selected_entitiy.x = line_to.x;
                        selected_entitiy.y = line_to.y;
                        selected_entitiy.args.to.x = from_x;
                        selected_entitiy.args.to.y = from_y;
                    } else {
                        selected_entitiy.x = from_x;
                        selected_entitiy.y = from_y;
                        selected_entitiy.args.to.x = line_to.x;
                        selected_entitiy.args.to.y = line_to.y;
                    }
                }

                this._selected_node = null;
                this._DrawSelected();
                this._DrawWall();
                break;
            }
            case EntitieTypes.POSITION:
                if (
                    LAGER_MAP_REOL_DEADZONE < this._DistanceBetweenTwoPoints(
                        this._selected_node.canvas_cursor_position.x,
                        this._selected_node.canvas_cursor_position.y,
                        args.canvas_cursor_position.x,
                        args.canvas_cursor_position.y,
                    )
                ) {
                    selected_entitiy.x = args.canvas_cursor_position.x + (selected_entitiy.x - this._selected_node.canvas_cursor_position.x);
                    selected_entitiy.y = args.canvas_cursor_position.y + (selected_entitiy.y - this._selected_node.canvas_cursor_position.y);
                }

                this._selected_node = null;
                this._DrawPos();
                break;

            default:
                break;
        }

        this._DrawCanvas();
    }

    //***************************************************
    // Event subroutines - node detect
    //***************************************************

    _EventMouseDown__NodeDetect__Wall(id_context, color_id, entity) {
        id_context.lineWidth = LAGER_MAP_WALL_WIDTH;
        let color_id_from = this._ReplaceCharacterAtIndex(color_id, 1, '1');
        id_context.beginPath();
        this._AliasedCircle(id_context, entity.x, entity.y, LAGER_MAP_WALL_END_SIZE);
        id_context.fillStyle = color_id_from;
        id_context.strokeStyle = color_id_from;
        id_context.fill();

        let color_id_to = this._ReplaceCharacterAtIndex(color_id, 1, '2');
        id_context.beginPath();
        this._AliasedCircle(id_context, entity.args.to.x, entity.args.to.y, LAGER_MAP_WALL_END_SIZE);
        id_context.fillStyle = color_id_to;
        id_context.strokeStyle = color_id_to;
        id_context.fill();
    }

    _EventMouseDown__NodeDetect__Pos(id_context, color_id, entity) {
        let delta_width = entity.args.width / this._uint_size_m;
        let delta_height = entity.args.length / this._uint_size_m;

        let offset_width = delta_width / 2;
        let offset_height = delta_height / 2;

        let cosθ = Math.cos(entity.args.angle * (Math.PI / 180));
        let sinθ = Math.sin(entity.args.angle * (Math.PI / 180));

        // Box
        let x_0 = -offset_width;
        let y_0 = -offset_height;

        let x_1 = delta_width - offset_width;
        let y_1 = -offset_height;

        let x_2 = delta_width - offset_width;
        let y_2 = delta_height - offset_height;

        let x_3 = -offset_width;
        let y_3 = delta_height - offset_height;

        // X_new = X_old x cos_θ – Y_old * sin_θ
        // Y_new = X_old x sin_θ + Y_old * cos_θ

        let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + entity.x;
        let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + entity.y;

        let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + entity.x;
        let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + entity.y;

        let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + entity.x;
        let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + entity.y;

        let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + entity.x;
        let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + entity.y;


        let color = this._ReplaceCharacterAtIndex(color_id, 1, '1');
        id_context.beginPath();
        this._AliasedPolygon4Points(id_context, color, x_0_θ, y_0_θ, x_1_θ, y_1_θ, x_2_θ, y_2_θ, x_3_θ, y_3_θ);
        id_context.fillStyle = color;
        id_context.strokeStyle = color;
        id_context.fill();
    }

    //***************************************************
    // Event subroutines - selected context
    //***************************************************

    _UpdateSelectedContext() {
        this._ShowContextMenu(false);
        this._context_menu.innerHTML = '';

        switch(this._selected_tool) {
            case ToolTypes.WALL:
                this._UpdateSelectedContext__Wall();
                break;

            case ToolTypes.CURSOR:
                this._menu_tool_cursor.dispatchEvent(new Event('pointerup'));
                if (this._selected_context?.id) {
                    let entity = this._entities[this._selected_context.id];
                    switch (entity?.type) {
                        case EntitieTypes.WALL:
                            this._UpdateSelectedContext__Wall();
                            break;

                        case EntitieTypes.POSITION:
                            this._UpdateSelectedContext__Pos();
                            break;

                        default:
                            break;
                    }
                }
                break;

            case ToolTypes.POSITION:
                this._UpdateSelectedContext__PositionCreate();
                break;

            default:
                break;
        }
    }

    _UpdateSelectedContext__Wall() {
        if (!this._selected_context?.id) return;

        let entity = this._entities[this._selected_context.id];
        if (!entity) return;

        let is_from_base = this._selected_context.opcode == 1;

        let header = document.createElement('div');
        header.style.display = 'flex';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';

        let heading = document.createElement('h3');
        heading.textContent = 'Wall';
        this._context_menu.appendChild(header);

        // from x
        let from_x = document.createElement('div');
        from_x.style.marginTop = '15px';
        from_x.className = 'label';
        this._context_menu.appendChild(from_x);

        let from_x_text = document.createElement('span');
        from_x_text.className = 'label-text';
        from_x_text.innerText = 'Horizontal position (m)';
        from_x.appendChild(from_x_text);

        let from_x_input = document.createElement('input');
        from_x_input.className = 'v-input';
        from_x_input.value = is_from_base ? entity.x : entity.args.to.x;
        from_x_input.type = 'number';
        from_x.appendChild(from_x_input);

        // from y
        let from_y = document.createElement('div');
        from_y.style.marginTop = '15px';
        from_y.className = 'label';
        this._context_menu.appendChild(from_y);

        let from_y_text = document.createElement('span');
        from_y_text.className = 'label-text';
        from_y_text.innerText = 'Vertical position (m)';
        from_y.appendChild(from_y_text);

        let from_y_input = document.createElement('input');
        from_y_input.className = 'v-input';
        from_y_input.value = is_from_base ? entity.y : entity.args.to.y;
        from_y_input.type = 'number';
        from_y.appendChild(from_y_input);

        // length
        let from_length = document.createElement('div');
        from_length.style.marginTop = '15px';
        from_length.className = 'label';
        this._context_menu.appendChild(from_length);

        let from_length_text = document.createElement('span');
        from_length_text.className = 'label-text';
        from_length_text.innerText = 'Length (m)';
        from_length.appendChild(from_length_text);

        let from_length_input = document.createElement('input');
        from_length_input.className = 'v-input';
        from_length_input.type = 'number';
        from_length_input.value = this._Round(this._uint_size_m * this._DistanceBetweenTwoPoints(
            entity.x,
            entity.y,
            entity.args.to.x,
            entity.args.to.y,
        ), LAGER_MAP_DECIMAL_PLACES);
        from_length.appendChild(from_length_input);

        // Apply input change on blur
        [from_x_input, from_y_input, from_length_input].map(input => {
            input.onkeydown = (event) => { if (event.key == 'Enter') input.blur() }
            input.onchange = () => {
                if (input.value < 0) input.value = 0;
                this._UpdateSelectedContext__WallEventApply(true, entity, from_x_input, from_y_input, from_length_input);
            }
        });

        // apply
        let apply_btn = document.createElement('button');
        apply_btn.className = 'icon apply';
        apply_btn.style.marginTop = '30px';
        apply_btn.style.width = '34px';
        apply_btn.style.height = '34px';
        apply_btn.style.border = '0';
        apply_btn.style.background = '#58bf5d';
        apply_btn.title = 'Apply';
        apply_btn.onclick = (event) => {
            event.preventDefault();
            this._UpdateSelectedContext__WallEventApply(true, entity, from_x_input, from_y_input, from_length_input);
        };
        //this._context_menu.appendChild(apply_btn);

        // delete
        let delete_btn = document.createElement('button');
        delete_btn.className = 'icon delete';
        //delete_btn.style.marginTop = '30px';
        //delete_btn.style.marginLeft = '30px';
        delete_btn.style.width = '34px';
        delete_btn.style.height = '34px';
        delete_btn.style.border = '0';
        delete_btn.style.outline = '0';
        delete_btn.style.background = '#ff686e';
        delete_btn.title = 'Delete';
        delete_btn.onclick = (event) => {
            event.preventDefault();
            this._DeleteEntryWall(entity);
            this._EventSelectedTool(null, this._selected_tool);
        };
        //this._context_menu.appendChild(delete_btn);
        header.append(heading, delete_btn);

        window.addEventListener('keydown', this._DeleteSelectedEntry);

        this._ShowContextMenu();
    }

    _UpdateSelectedContext__Pos() {
        if (!this._selected_context?.id) return;

        let entity = this._entities[this._selected_context.id];
        if (!entity) return;

        let header = document.createElement('div');
        header.style.display = 'flex';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';

        let heading = document.createElement('h3');
        heading.textContent = 'Aisle';
        this._context_menu.appendChild(header);

        // Aisle
        let from_aisle = document.createElement('div');
        from_aisle.style.marginTop = '15px';
        from_aisle.className = 'label';
        this._context_menu.appendChild(from_aisle);

        let from_aisle_text = document.createElement('span');
        from_aisle_text.className = 'label-text';
        from_aisle_text.innerText = 'ID (unique)';
        from_aisle.appendChild(from_aisle_text);

        let from_aisle_input = document.createElement('input');
        from_aisle_input.className = 'v-input';
        from_aisle_input.value = entity.args.aisle;
        from_aisle_input.type = 'text';
        from_aisle_input.placeholder = '{NOT SET}';
        from_aisle.appendChild(from_aisle_input);

        // Racks
        let from_racks = document.createElement('div');
        from_racks.style.marginTop = '15px';
        from_racks.className = 'label';
        this._context_menu.appendChild(from_racks);

        let from_racks_text = document.createElement('span');
        from_racks_text.className = 'label-text';
        from_racks_text.innerText = 'Racks';
        from_racks.appendChild(from_racks_text);

        let from_racks_wrapper = document.createElement('div');
        let from_racks_input = document.createElement('input');
        let from_racks_wrapper_input_button = document.createElement('button');
        from_racks_wrapper.className = 'v-wrapper border';
        from_racks_input.className = 'v-wrapper-input';
        from_racks_wrapper_input_button.className = 'v-wrapper-input-button icon edit';
        from_racks_wrapper_input_button.title = 'Edit';
        from_racks_input.value = entity.args.racks;
        from_racks_input.type = 'number';
        from_racks_input.style.border = 0;
        from_racks_wrapper_input_button.style.border = 0;
        // Edit racks
        from_racks_wrapper_input_button.onclick = () => {
            new LaggerMapEditRacksPopup(this._dialog, entity, () => {
                this._DrawPos();
                this._DrawCanvas();
            });
        }
        from_racks_wrapper.append(from_racks_input, from_racks_wrapper_input_button);
        from_racks.appendChild(from_racks_wrapper);

        // X
        let from_x = document.createElement('div');
        from_x.style.marginTop = '15px';
        from_x.className = 'label';
        this._context_menu.appendChild(from_x);

        let from_x_text = document.createElement('span');
        from_x_text.className = 'label-text';
        from_x_text.innerText = 'Horizontal position (m)';
        from_x.appendChild(from_x_text);

        let from_x_input = document.createElement('input');
        from_x_input.className = 'v-input';
        from_x_input.value = entity.x;
        from_x_input.type = 'number';
        from_x.appendChild(from_x_input);

        // Y
        let from_y = document.createElement('div');
        from_y.style.marginTop = '15px';
        from_y.className = 'label';
        this._context_menu.appendChild(from_y);

        let from_y_text = document.createElement('span');
        from_y_text.className = 'label-text';
        from_y_text.innerText = 'Vertical position (m)';
        from_y.appendChild(from_y_text);

        let from_y_input = document.createElement('input');
        from_y_input.className = 'v-input';
        from_y_input.value = entity.y;
        from_y_input.type = 'number';
        from_y.appendChild(from_y_input);

        // Length (cm)
        let from_length = document.createElement('div');
        from_length.style.marginTop = '15px';
        from_length.className = 'label';
        this._context_menu.appendChild(from_length);

        let from_length_text = document.createElement('span');
        from_length_text.className = 'label-text';
        from_length_text.innerText = 'Length (cm)';
        from_length.appendChild(from_length_text);

        let from_length_input = document.createElement('input');
        from_length_input.className = 'v-input';
        from_length_input.value = parseInt(entity.args.length * 100);
        from_length_input.type = 'number';
        from_length.appendChild(from_length_input);

        // Width (cm)
        let from_width = document.createElement('div');
        from_width.style.marginTop = '15px';
        from_width.className = 'label';
        this._context_menu.appendChild(from_width);

        let from_width_text = document.createElement('span');
        from_width_text.className = 'label-text';
        from_width_text.innerText = 'Width (cm)';
        from_width.appendChild(from_width_text);

        let from_width_input = document.createElement('input');
        from_width_input.className = 'v-input';
        from_width_input.value = parseInt(entity.args.width * 100);
        from_width_input.type = 'number';
        from_width.appendChild(from_width_input);

        // Angle (degrees)
        let from_angle = document.createElement('div');
        from_angle.style.marginTop = '15px';
        from_angle.className = 'label';
        this._context_menu.appendChild(from_angle);

        let from_angle_text = document.createElement('span');
        from_angle_text.className = 'label-text';
        from_angle_text.innerText = 'Angle (degrees)';
        from_angle.appendChild(from_angle_text);

        let from_angle_input = document.createElement('input');
        from_angle_input.className = 'v-input';
        from_angle_input.value = entity.args.angle;
        from_angle_input.type = 'number';
        from_angle.appendChild(from_angle_input);
        
        // Apply input change on blur
        [from_aisle_input, from_racks_input, from_x_input, from_y_input, from_length_input, from_width_input, from_angle_input].map(input => {
            input.onkeydown = (event) => { if (event.key == 'Enter') input.blur() }
            input.onchange = () => {
                if (input.type == 'number') {
                    if (input.value <= 0) {
                        if (input == from_angle_input) {
                            input.value = 0;
                        } else {
                            input.value = 1;
                        }
                    }
                }
                this._UpdateSelectedContext__PosEventApply(
                    entity,
                    from_x_input.value,
                    from_y_input.value,
                    from_length_input.value / 100,
                    from_width_input.value / 100,
                    from_angle_input.value,
                    from_aisle_input.value,
                    from_racks_input.value,
                );
            }
        });

        // Apply
        let apply_btn = document.createElement('button');
        apply_btn.className = 'icon apply';
        apply_btn.style.marginTop = '30px';
        apply_btn.style.width = '34px';
        apply_btn.style.height = '34px';
        apply_btn.style.border = '0';
        apply_btn.style.background = '#58bf5d';
        apply_btn.title = 'Apply';
        apply_btn.onclick = (event) => {
            event.preventDefault();
            this._UpdateSelectedContext__PosEventApply(
                entity,
                from_x_input.value,
                from_y_input.value,
                from_length_input.value / 100,
                from_width_input.value / 100,
                from_angle_input.value,
                from_aisle_input.value,
                from_racks_input.value,
            );
        };
        //this._context_menu.appendChild(apply_btn);

        // Delete
        let delete_btn = document.createElement('button');
        delete_btn.className = 'icon delete';
        //delete_btn.style.marginTop = '30px';
        //delete_btn.style.marginLeft = '30px';
        delete_btn.style.width = '34px';
        delete_btn.style.height = '34px';
        delete_btn.style.border = '0';
        delete_btn.style.outline = '0';
        delete_btn.style.background = '#ff686e';
        delete_btn.title = 'Delete';
        delete_btn.onclick = (event) => {
            event.preventDefault();
            this._DeleteEntryPosition(entity);
            this._EventSelectedTool(null, this._selected_tool);
        };
        //this._context_menu.appendChild(delete_btn);
        header.append(heading, delete_btn);
        
        this._UpdateSelectedContext__PosEventApply(
            entity,
            from_x_input.value,
            from_y_input.value,
            from_length_input.value / 100,
            from_width_input.value / 100,
            from_angle_input.value,
            from_aisle_input.value,
            from_racks_input.value,
        );

        window.addEventListener('keydown', this._DeleteSelectedEntry);

        this._ShowContextMenu();
    }

    _UpdateSelectedContext__PositionCreate() {
        if (!this._context_menu_pos_input)  {
            this._context_menu_pos_input = {
                increment: '',
                aisle: '',
                racks: 1,
                length: 1.3,
                width: 0.5,
                angle: 0
            };
        }

        let header = document.createElement('div');
        header.style.height = '34px';
        header.style.display = 'flex';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';

        let heading = document.createElement('h3');
        heading.textContent = 'Aisle';
        header.appendChild(heading);
        this._context_menu.appendChild(header);

        // Aisle
        let from_aisle = document.createElement('div');
        from_aisle.style.marginTop = '15px';
        from_aisle.className = 'label';
        this._context_menu.appendChild(from_aisle);

        let from_aisle_text = document.createElement('span');
        from_aisle_text.className = 'label-text';
        from_aisle_text.innerText = 'ID (unique)';
        from_aisle.appendChild(from_aisle_text);

        let from_aisle_input_value = this._context_menu_pos_input.aisle;
        if (from_aisle_input_value) {
            let incremental_value = (from_aisle_input_value.match(/\d+/) || [])[0];
            if (incremental_value) {
                let value = from_aisle_input_value;
                let number = incremental_value;
                let zeroes = number.replace(/\d/g, 0);
                let increment = (+number) + 1;
                increment = (zeroes + increment).slice(-number.length);
                from_aisle_input_value = value.replace(new RegExp(number), increment);
            } else {
                from_aisle_input_value = from_aisle_input_value + 1;
            }
            this._context_menu_pos_input.aisle = from_aisle_input_value;
        }
        let from_aisle_input = document.createElement('input');
        from_aisle_input.className = 'v-input';
        from_aisle_input.value = from_aisle_input_value;
        from_aisle_input.type = 'text';
        from_aisle_input.data = 'aisle';
        from_aisle_input.placeholder = '{NOT SET}';
        from_aisle.appendChild(from_aisle_input);

        // Racks
        let from_racks = document.createElement('div');
        from_racks.style.marginTop = '15px';
        from_racks.className = 'label';
        this._context_menu.appendChild(from_racks);

        let from_racks_text = document.createElement('span');
        from_racks_text.className = 'label-text';
        from_racks_text.innerText = 'Racks';
        from_racks.appendChild(from_racks_text);

        let from_racks_input = document.createElement('input');
        from_racks_input.className = 'v-input';
        from_racks_input.value = this._context_menu_pos_input.racks;
        from_racks_input.type = 'number';
        from_racks_input.data = 'racks';
        from_racks.appendChild(from_racks_input);

        // Length (cm)
        let from_length = document.createElement('div');
        from_length.style.marginTop = '15px';
        from_length.className = 'label';
        this._context_menu.appendChild(from_length);

        let from_length_text = document.createElement('span');
        from_length_text.className = 'label-text';
        from_length_text.innerText = 'Length (cm)';
        from_length.appendChild(from_length_text);

        let from_length_input = document.createElement('input');
        from_length_input.className = 'v-input';
        from_length_input.value = parseInt(this._context_menu_pos_input.length * 100);
        from_length_input.type = 'number';
        from_length_input.data = 'length';
        from_length.appendChild(from_length_input);

        // Width (cm)
        let from_width = document.createElement('div');
        from_width.style.marginTop = '15px';
        from_width.className = 'label';
        this._context_menu.appendChild(from_width);

        let from_width_text = document.createElement('span');
        from_width_text.className = 'label-text';
        from_width_text.innerText = 'Width (cm)';
        from_width.appendChild(from_width_text);

        let from_width_input = document.createElement('input');
        from_width_input.className = 'v-input';
        from_width_input.value = parseInt(this._context_menu_pos_input.width * 100);
        from_width_input.type = 'number';
        from_width_input.data = 'width';
        from_width.appendChild(from_width_input);

        // Angle (degrees)
        let from_angle = document.createElement('div');
        from_angle.style.marginTop = '15px';
        from_angle.className = 'label';
        this._context_menu.appendChild(from_angle);

        let from_angle_text = document.createElement('span');
        from_angle_text.className = 'label-text';
        from_angle_text.innerText = 'Angle (degrees)';
        from_angle.appendChild(from_angle_text);

        let from_angle_input = document.createElement('input');
        from_angle_input.className = 'v-input';
        from_angle_input.value = this._context_menu_pos_input.angle;
        from_angle_input.type = 'number';
        from_angle_input.data = 'angle';
        from_angle.appendChild(from_angle_input);

        // Apply input change on blur
        [from_aisle_input, from_racks_input, from_length_input, from_width_input, from_angle_input].map(input => {
            input.onkeydown = (event) => { if (event.key == 'Enter') input.blur() }
            input.onchange = () => {
                let value = input.value;
                if (/length|width/.test(input.data)) {
                    value = parseInt(value) / 100;
                }
                this._context_menu_pos_input[input.data] = value;
            }
        });

        this._ShowContextMenu();
    }

    _UpdateSelectedContext__WallEventApply(is_from_base, entity, from_x_input, from_y_input, length_input) {
        let from_x = parseInt(from_x_input.value);
        let from_y = parseInt(from_y_input.value);
        let length = parseFloat(length_input.value) / this._uint_size_m;

        if (from_x < 0 || from_x > LAGER_MAP_CANVAS_HEIGHT) {
            this._Message(
                'The x value is not valid',
                `X must be between 0 and ${LAGER_MAP_CANVAS_HEIGHT}`
            );
            return;
        }

        if (from_y < 0 || from_y > LAGER_MAP_CANVAS_WIDTH) {
            this._Message(
                'The y value is not valid',
                `Y must be between 0 and ${LAGER_MAP_CANVAS_WIDTH}`
            );
            return;
        }

        let entity_from_x, entity_from_y, entity_to_x, entity_to_y;
        if (is_from_base) {
            entity_from_x = entity.x;
            entity_from_y = entity.y;
            entity_to_x = entity.args.to.x;
            entity_to_y = entity.args.to.y;
        } else {
            entity_from_x = entity.args.to.x;
            entity_from_y = entity.args.to.y;
            entity_to_x = entity.x;
            entity_to_y = entity.y;
        }

        let { angle } = this._SnapLineTo45DegreeAngleValue(
            entity_from_x,
            entity_from_y,
            entity_to_x,
            entity_to_y,
        );
        let result = this._SnapLineTo45DegreeAngleCalc(
            from_x,
            from_y,
            length,
            angle,
            LAGER_MAP_CANVAS_HEIGHT,
            LAGER_MAP_CANVAS_WIDTH,
        );

        if (is_from_base) {
            entity.x = from_x;
            entity.y = from_y;
            entity.args.to.x = result.x;
            entity.args.to.y = result.y;
        } else {
            entity.x = result.x;
            entity.y = result.y;
            entity.args.to.x = from_x;
            entity.args.to.y = from_y;
        }

        let new_length = this._Round(this._uint_size_m * this._DistanceBetweenTwoPoints(
            entity.x,
            entity.y,
            entity.args.to.x,
            entity.args.to.y,
        ), LAGER_MAP_DECIMAL_PLACES);

        if (new_length != length_input.value) {
            this._Message(
                'New length is invalid',
                `The length has ben set to ${this._Round(new_length)}`,
                true,
            );
            length_input.value = new_length;
        }

        let context_offscreen_canvas_gui = this._offscreen_canvas_gui.getContext('2d');
        context_offscreen_canvas_gui.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        this._DrawSelected();
        this._DrawWall();
        this._DrawCanvas();
        this._ShowContextMenu();
    }

    _UpdateSelectedContext__PosEventApply(entity, x, y, length, width, angle, aisle, racks) {
        let from_x = parseInt(x);
        let from_y = parseInt(y);
        let from_length = parseFloat(length);
        let from_width = parseFloat(width);
        let from_angle = parseFloat(angle);
        let from_racks = parseInt(racks);

        if (from_x < 0 || from_x > LAGER_MAP_CANVAS_HEIGHT) {
            this._Message(
                'The x value is not valid',
                `X must be between 0 and ${LAGER_MAP_CANVAS_HEIGHT}`
            );
            return;
        }

        if (from_y < 0 || from_y > LAGER_MAP_CANVAS_WIDTH) {
            this._Message(
                'The y value is not valid',
                `Y must be between 0 and ${LAGER_MAP_CANVAS_WIDTH}`
            );
            return;
        }

        if (from_length < 0) {
            this._Message(
                'The Length is not valid',
                'Length must be more then 0',
            );
            return;
        }

        if (from_width < 0) {
            this._Message(
                'The width is not valid',
                'Width must be more then 0',
            );
            return;
        }

        if (from_angle < 0 || from_angle > 360) {
            this._Message(
                'The angle is not valid',
                'Angle must be between 0 and 360',
            );
            return;
        }

        if (from_racks < 1) {
            this._Message(
                'The racks is not valid',
                'Racks must more then 0',
            );
            return;
        }

        entity.x = from_x;
        entity.y = from_y;
        entity.args.aisle = aisle;
        entity.args.length = from_length;
        entity.args.width = from_width;
        entity.args.angle = from_angle;
        entity.args.racks = from_racks;

        if (entity.args.racks > entity.args.racks_data.length) {
            for (let i = 0; i < entity.args.racks; i++) {
                if (!(i in entity.args.racks_data)) entity.args.racks_data[i] = (i + 1).toString();
            }
        } else if (entity.args.racks < entity.args.racks_data.length) {
            entity.args.racks_data = entity.args.racks_data.slice(0, entity.args.racks);
        }

        let context_offscreen_canvas_gui = this._offscreen_canvas_gui.getContext('2d');
        context_offscreen_canvas_gui.clearRect(0, 0, this._offscreen_canvas_gui.width, this._offscreen_canvas_gui.height);

        this._DrawSelected();
        this._DrawPos();
        this._DrawCanvas();
        this._ShowContextMenu();
    }

    //***************************************************
    // Draw
    //***************************************************

    _DrawCanvas(scale) {
        // console.debug('_DrawCanvas');
        if (scale) {
            if (this._scale != scale) {
                this._scale = scale;
                this._canvas.height = LAGER_MAP_CANVAS_HEIGHT * this._scale;
                this._canvas.width = LAGER_MAP_CANVAS_WIDTH * this._scale;
            }
        }

        let bounding_canvas_container = this._canvas_container.getBoundingClientRect();
        let bounding_canvas = this._canvas.getBoundingClientRect();

        let margin_height = 20;
        let margin_width = 20;

        if (bounding_canvas_container.height > bounding_canvas.height) {
            margin_height = bounding_canvas_container.height - bounding_canvas.height;
            margin_height /= 2;
        }

        if (bounding_canvas_container.width > bounding_canvas.width) {
            margin_width = bounding_canvas_container.width - bounding_canvas.width;
            margin_width /= 2;
        }

        this._canvas.style.margin = `${margin_height}px ${margin_width}px`;

        let context = this._canvas.getContext('2d');
        context.clearRect(0, 0, this._canvas.width, this._canvas.height);

        context.drawImage(this._offscreen_canvas_background, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offscreen_canvas_pos, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offscreen_canvas_wall, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offsereen_canvas_start, 0, 0, this._canvas.width, this._canvas.height);
        context.drawImage(this._offscreen_canvas_gui, 0, 0, this._canvas.width, this._canvas.height);
    }

    _DrawStart() {
        let context = this._offsereen_canvas_start.getContext('2d');
        context.clearRect(0, 0, this._offsereen_canvas_start.width, this._offsereen_canvas_start.height);

        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let offset = ids[i];
            if (this._entities[offset]?.type == EntitieTypes.START) {
                let start_node = this._entities[offset];

                context.beginPath();
                context.arc(start_node.x, start_node.y, 14, 0, 2 * Math.PI);
                context.fillStyle = "#000000";
                context.fill();
                context.stroke();

                context.beginPath();
                context.arc(start_node.x, start_node.y, 10, 0, 2 * Math.PI);
                context.fillStyle = "#FFFFFF";
                context.fill();
                context.stroke();

                context.beginPath();
                context.arc(start_node.x, start_node.y, 6, 0, 2 * Math.PI);
                context.fillStyle = "#000000";
                context.fill();
                context.stroke();
            }
        }
    }

    _DrawBackground() {
        let step_of_ten  = LAGER_MAP_BACKGROUND_STEP * 10;

        let context = this._offscreen_canvas_background.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_background.width, this._offscreen_canvas_background.height);

        for (let i = 0; i < this._offscreen_canvas_background.width; i += LAGER_MAP_BACKGROUND_STEP) {
            context.beginPath();
            context.lineWidth = 1;
            context.strokeStyle = i % step_of_ten == 0 ? "#00000080" : "#00000030";
            context.moveTo(i, 0);
            context.lineTo(i, this._offscreen_canvas_background.height);
            context.stroke();
        }

        for (let i = 0; i < this._offscreen_canvas_background.height; i += LAGER_MAP_BACKGROUND_STEP) {
            context.beginPath();
            context.lineWidth = 1;
            context.strokeStyle = i % step_of_ten == 0 ? "#00000080" : "#00000030";
            context.moveTo(0, i);
            context.lineTo(this._offscreen_canvas_background.width, i);
            context.stroke();
        }
    }

    _DrawWall() {
        let context = this._offscreen_canvas_wall.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_wall.width, this._offscreen_canvas_wall.height);

        let skip_id = null;
        if (this._selected_tool == ToolTypes.CURSOR) {
            skip_id = this._selected_node?.cursor?.id;
        }

        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let entity = this._entities[ids[i]];
            if (entity.type != EntitieTypes.WALL || entity.id == skip_id) continue;

            context.lineWidth = LAGER_MAP_WALL_WIDTH;

            context.beginPath();
            context.moveTo(entity.x, entity.y);
            context.lineTo(entity.args.to.x, entity.args.to.y);
            context.stroke();

            context.beginPath();
            context.arc(entity.x, entity.y, LAGER_MAP_WALL_END_SIZE, 0, 2 * Math.PI);
            context.fillStyle = "#000000";
            context.fill();
            context.stroke();

            context.beginPath();
            context.arc(entity.args.to.x, entity.args.to.y, LAGER_MAP_WALL_END_SIZE, 0, 2 * Math.PI);
            context.fillStyle = "#000000";
            context.fill();
            context.stroke();
        }
    }

    _DrawPos() {
        let context = this._offscreen_canvas_pos.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_pos.width, this._offscreen_canvas_pos.height);

        context.font = `${LAGER_MAP_REOL_FONT_WEIGHT} ${LAGER_MAP_REOL_FONT_SIZE}px ${LAGER_MAP_FONT}`;

        let skip_id = null;
        if (this._selected_tool == ToolTypes.CURSOR) {
            skip_id = this._selected_node?.cursor?.id;
        }

        let ids = Object.keys(this._entities);
        for (let i = 0; i < ids.length; i++) {
            let entity = this._entities[ids[i]];

            if (entity.type != EntitieTypes.POSITION || entity.id == skip_id) continue;

            let has_error = false; // check if the same aisle and rack in use
            for (let j = 0; j < ids.length && !has_error; j++) {
                let item = this._entities[ids[j]];
                if (item.type != EntitieTypes.POSITION || entity.id == item.id) continue;

                if (item.args.aisle == entity.args.aisle) {
                    for (let j = 0; j < entity.args.racks_data.length && !has_error; j++) {
                        let entity_rack = entity.args.racks_data[j];

                        for (let k = 0; k < item.args.racks_data.length && !has_error; k++) {
                            let item_rack = item.args.racks_data[k];
                            has_error = entity_rack == item_rack;
                        }
                    }
                }
            }

            let delta_width = entity.args.width / this._uint_size_m;
            let delta_height = entity.args.length / this._uint_size_m;

            let offset_width = delta_width / 2;
            let offset_height = delta_height / 2;

            let cosθ = Math.cos(entity.args.angle * (Math.PI / 180));
            let sinθ = Math.sin(entity.args.angle * (Math.PI / 180));

            // Box
            let x_0 = -offset_width;
            let y_0 = -offset_height;

            let x_1 = delta_width - offset_width;
            let y_1 = -offset_height;

            let x_2 = delta_width - offset_width;
            let y_2 = delta_height - offset_height;

            let x_3 = -offset_width;
            let y_3 = delta_height - offset_height;

            // X_new = X_old x cos_θ – Y_old * sin_θ
            // Y_new = X_old x sin_θ + Y_old * cos_θ

            let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + entity.x;
            let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + entity.y;

            let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + entity.x;
            let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + entity.y;

            let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + entity.x;
            let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + entity.y;

            let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + entity.x;
            let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + entity.y;

            context.lineWidth = LAGER_MAP_WALL_WIDTH;
            context.lineStyle = LAGER_MAP_REOL_LINE_STYLE;
            context.fillStyle = has_error ? LAGER_MAP_REOL_FILL_STYLE_ERROR : LAGER_MAP_REOL_FILL_STYLE;

            context.beginPath();
            context.moveTo(x_0_θ, y_0_θ);
            context.lineTo(x_1_θ, y_1_θ);
            context.lineTo(x_2_θ, y_2_θ);
            context.lineTo(x_3_θ, y_3_θ);
            context.lineTo(x_0_θ, y_0_θ);
            context.closePath();

            context.stroke();
            context.fill();

            context.save();
            if (entity.args.angle < 90)  {
                context.translate(x_0_θ, y_0_θ);
            } else if (entity.args.angle < 270) {
                context.translate(x_3_θ, y_3_θ);
            } else {
                context.translate(x_0_θ, y_0_θ);
            }

            context.rotate(-Math.PI / 4);
            context.fillStyle = has_error ? LAGER_MAP_REOL_FILL_STYLE_ERROR : !entity.args.aisle ? LAGER_MAP_REOL_FILL_STYLE : '#000000';
            context.fillText(entity.args.aisle ? entity.args.aisle : '{NOT SET}', 10, 0);
            context.restore();

            // Separate and gate
            context.fillStyle = LAGER_MAP_REOL_GATE_FILL_STYLE;

            let separate_gap = entity.args.length / this._uint_size_m / entity.args.racks;
            let separate_gap_half = separate_gap / 2;
            for (let i = 0; i < entity.args.racks; i++) {
                let separate_x_0 = -offset_width;
                let separate_y_0 = -offset_height + (separate_gap * i);
                let separate_x_1 = offset_width;
                let separate_y_1 = separate_y_0;

                let separate_x_0_θ = (separate_x_0 * cosθ) - (separate_y_0 * sinθ) + entity.x;
                let separate_y_0_θ = (separate_x_0 * sinθ) + (separate_y_0 * cosθ) + entity.y;

                let separate_x_1_θ = (separate_x_1 * cosθ) - (separate_y_1 * sinθ) + entity.x;
                let separate_y_1_θ = (separate_x_1 * sinθ) + (separate_y_1 * cosθ) + entity.y;

                if (i != 0) {
                    context.beginPath();
                    context.moveTo(separate_x_0_θ, separate_y_0_θ);
                    context.lineTo(separate_x_1_θ, separate_y_1_θ);
                    context.stroke();
                }

                let separate_gate_x_θ = (separate_x_0 * cosθ) - ((separate_y_0 + separate_gap_half) * sinθ) + entity.x;
                let separate_gate_y_θ = (separate_x_0 * sinθ) + ((separate_y_0 + separate_gap_half) * cosθ) + entity.y;

                context.beginPath();
                context.arc(separate_gate_x_θ, separate_gate_y_θ, LAGER_MAP_REOL_GATE_SIZE, 0, Math.PI * 2);
                context.fill();
                context.stroke();

                context.save();

                context.font = `${LAGER_MAP_REOL_FONT_SIZE}px ${LAGER_MAP_FONT}`;
                context.textBaseline = 'top';

                let text = entity.args.racks_data[i];
                let width = context.measureText(text).width;

                context.fillStyle = '#f50';
                context.fillRect(separate_gate_x_θ, separate_gate_y_θ, width + 2, LAGER_MAP_REOL_FONT_SIZE);

                context.fillStyle = '#000';
                context.fillText(text, separate_gate_x_θ, separate_gate_y_θ + 2);

                context.restore();
            }
        }
    }

    _DrawSelected() {
        // console.debug('_selected_context', this._selected_context);

        if (this._selected_context?.id == null) return;

        let entity = this._entities[this._selected_context.id];
        if (!entity) return;

        let context = this._offscreen_canvas_gui.getContext('2d');
        context.save();
        context.strokeStyle = LAGER_MAP_STROKE_STYLE_SELECTED;
        context.fillStyle = LAGER_MAP_FILL_STYLE_SELECTED;

        switch (entity.type) {
            case EntitieTypes.POSITION:
                this._DrawSelected__Position(context, entity);
                break;

            case EntitieTypes.WALL:
                this._DrawSelected__Wall(context, entity);
                break;
        
            default:
                break;
        }
        context.restore();
    }

    _DrawSelected__Position(context, entity) {
        let delta_width = entity.args.width / this._uint_size_m;
        let delta_height = entity.args.length / this._uint_size_m;

        let offset_width = delta_width / 2;
        let offset_height = delta_height / 2;

        let cosθ = Math.cos(entity.args.angle * (Math.PI / 180));
        let sinθ = Math.sin(entity.args.angle * (Math.PI / 180));

        // Box
        let x_0 = -offset_width - 10;
        let y_0 = -offset_height - 10;

        let x_1 = delta_width - offset_width + 10;
        let y_1 = -offset_height - 10;

        let x_2 = delta_width - offset_width + 10;
        let y_2 = delta_height - offset_height + 10;

        let x_3 = -offset_width - 10;
        let y_3 = delta_height - offset_height + 10;

        let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + entity.x;
        let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + entity.y;

        let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + entity.x;
        let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + entity.y;

        let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + entity.x;
        let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + entity.y;

        let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + entity.x;
        let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + entity.y;

        context.beginPath();
        context.moveTo(x_0_θ, y_0_θ);
        context.lineTo(x_1_θ, y_1_θ);
        context.lineTo(x_2_θ, y_2_θ);
        context.lineTo(x_3_θ, y_3_θ);
        context.lineTo(x_0_θ, y_0_θ);
        context.stroke();
        context.fill();
        context.closePath();
    }

    _DrawSelected__Wall(context, entity) {
        let x, y;
        
        if (this._selected_context?.opcode == 1) {
            x = entity.x;
            y = entity.y;
        } else {
            x = entity.args.to.x;
            y = entity.args.to.y;
        }

        context.beginPath();
        context.arc(x, y, LAGER_MAP_REOL_GATE_SIZE + 10, 0, Math.PI * 2);
        context.stroke();
        context.fill();
        context.closePath();
    }

    //***************************************************
    // Helpers
    //***************************************************

    _NextEntryId() {
        return ++this._next_id;
    }

    _AddEntryWall(from_x, from_y, to_x, to_y) {
        let id = this._NextEntryId();
        this._entities[id] = {
            'id': id,
            'type': EntitieTypes.WALL,
            'x': from_x,
            'y': from_y,
            'args': {
                'to':  {
                    'x': to_x,
                    'y': to_y,
                }
            }
        };

        return this._entities[id];
    }

    _AddEntryPos(x, y, length, width, angle, aisle, racks) {
        let id = this._NextEntryId();

        let racks_data = [];
        for (let i = 0; i < racks; i++) racks_data[i] = (i + 1).toString();

        this._entities[id] = {
            'id': id,
            'type': EntitieTypes.POSITION,
            'x': x,
            'y': y,
            'args': {
                'length': length,
                'width': width,
                'angle': angle,
                'aisle': aisle,
                'racks': racks,
                'racks_data': racks_data,
            }
        };

        return this._entities[id];
    }

    _DeleteSelectedEntry = (event) => {
        if (event.key != 'Delete') return;
        if (document.activeElement?.localName == 'input') return;
        window.removeEventListener('keydown', this._DeleteSelectedEntry);
        let entry = this._entities[this._selected_context.id];
        if (entry?.type == EntitieTypes.WALL) {
            this._DeleteEntryWall(entry);
        }
        if (entry?.type == EntitieTypes.POSITION) {
            this._DeleteEntryPosition(entry);
        }
        this._EventSelectedTool(null, this._selected_tool);
    }

    _DeleteEntryWall(entry) {
        if (!entry) throw `The entry is not set`;
        if (entry?.type != EntitieTypes.WALL) throw `The object with id ${entry?.id} is not og type EntitieTypes.WALL`;
        delete this._entities[entry.id];
    }

    _DeleteEntryPosition(entry) {
        if (!entry) throw `The entry is not set`;
        if (entry?.type != EntitieTypes.POSITION) throw `The object with id ${entry?.id} is not og type EntitieTypes.POSITION`;
        delete this._entities[entry.id];
    }

    _AddEventListener(target, event_name, callback, options = null) {
        target.addEventListener(event_name, callback, options);
        this._event_listeners.push({
            'target': target,
            'event_name': event_name,
            'callback': callback,
            'options': options,
        });
    }

    _CanvasCursorPosition(event) {
        let rect = this._canvas.getBoundingClientRect();
        return {
            'x': parseInt((event.clientX - rect.left) / this._scale),
            'y': parseInt((event.clientY - rect.top) / this._scale),
        }
    }

    _SnapLineTo45DegreeAngleValue(start_x, start_y, end_x, end_y) {
        let x2 = end_x - start_x;
        let y2 = end_y - start_y;
        let r = Math.sqrt(x2 * x2 + y2 * y2);
        let angle = (Math.atan2(y2, x2) / Math.PI * 180);

        angle = (angle) % 360 + 180;

        if (angle <= 22.5 || angle >= 337.5) {
            angle = 0;
        } else if (angle <= 67.5) {
            angle = 45;
        } else if (angle <= 112.5) {
            angle = 90;
        } else if (angle <= 157.5) {
            angle = 135;
        } else if (angle <= 202.5) {
            angle = 180;
        } else if (angle <= 247.5) {
            angle = 225;
        } else if (angle <= 292.5) {
            angle = 270;
        } else if (angle < 337.5) {
            angle = 315;
        }

        angle -= 180;

        return { r, angle };
    }

    _SnapLineTo45DegreeAngleCalc(start_x, start_y, r, angle, max_x, max_y) {
        let cosx = r * Math.cos(angle * Math.PI / 180);
        let sinx = r * Math.sin(angle * Math.PI / 180);

        let result = { 'x': cosx + start_x, 'y': sinx + start_y };

        if (angle % 90 != 0) {
            // f(x) = a + (b * x)
            let b = (result.x - start_x) / (result.y - start_y);
            let a = result.y - (result.x * b);

            if (result.x < 0) {
                result.x = 0;
                result.y = a;
            }

            if (result.y < 0) {
                result.x = -a / b;
                result.y = 0;
            }

            if (result.x > max_x) {
                result.x = max_x;
                result.y = a + (b * max_x);
            }

            if (result.y > max_y) {
                result.x = (max_y - a) / b;
                result.y = max_y;
            }
        }

        result.x = Math.round(result.x);
        result.y = Math.round(result.y);

        return result;
    }

    _SnapLineTo45DegreeAngle(start_x, start_y, end_x, end_y, max_x, max_y) {
        let { r, angle } = this._SnapLineTo45DegreeAngleValue(start_x, start_y, end_x, end_y);
        return this._SnapLineTo45DegreeAngleCalc(start_x, start_y, r, angle, max_x, max_y);
    }

    _ReplaceCharacterAtIndex(string, index, value) {
        return string.substring(0, index)
            + value
            + string.substring(index + 1);
    }

    _AliasedCircle(ctx, xc, yc, r) {  // NOTE: for fill only!
        let x = r, y = 0, cd = 0;

        // middle line
        ctx.rect(xc - x, yc, r<<1, 1);

        while (x > y) {
            cd -= (--x) - (++y);
            if (cd < 0) cd += x++;
            ctx.rect(xc - y, yc - x, y<<1, 1);    // upper 1/4
            ctx.rect(xc - x, yc - y, x<<1, 1);    // upper 2/4
            ctx.rect(xc - x, yc + y, x<<1, 1);    // lower 3/4
            ctx.rect(xc - y, yc + x, y<<1, 1);    // lower 4/4
        }
    }

    _AliasedPolygon4Points(ctx, color_id, x_0, y_0, x_1, y_1, x_2, y_2, x_3, y_3) {  // NOTE: for fill only!
        let color_id_str = '#AAAAAAFF';
        let color_id_int = parseInt(this._ReplaceCharacterAtIndex(color_id_str, 0, '0'), 16);

        let from_x = Math.min(x_0, x_1, x_2, x_3);
        let from_y = Math.min(y_0, y_1, y_2, y_3);
        let to_x   = Math.max(x_0, x_1, x_2, x_3);
        let to_y   = Math.max(y_0, y_1, y_2, y_3);

        let offsets = null;
        if (this._cache_pos_cursor[color_id]) {
            let cache = this._cache_pos_cursor[color_id];
            if (
                   x_0 == cache.args.x_0
                && y_0 == cache.args.y_0
                && x_1 == cache.args.x_1
                && y_1 == cache.args.y_1
                && x_2 == cache.args.x_2
                && y_2 == cache.args.y_2
                && x_3 == cache.args.x_3
                && y_3 == cache.args.y_3
            ) {
                offsets = cache.offsets;
            }
        }

        if (!offsets) {
            offsets = this._AliasedPolygon4Points__Calc(
                color_id_str, color_id_int, x_0, y_0, x_1, y_1, x_2, y_2, x_3, y_3, from_x, from_y, to_x, to_y
            );

            this._cache_pos_cursor[color_id] = {
                'offsets': offsets,
                'args': {
                    'x_0': x_0, 
                    'y_0': y_0, 
                    'x_1': x_1, 
                    'y_1': y_1, 
                    'x_2': x_2, 
                    'y_2': y_2, 
                    'x_3': x_3, 
                    'y_3': y_3,
                }
            }
        }
        
        let from_x_base = Math.round(from_x);
        let from_y_base = Math.round(from_y);
        for (let i = 0; i < offsets.length; i++) {
            let offset = offsets[i];
            ctx.rect(
                offset.from.x + from_x_base,
                offset.from.y + from_y_base,
                offset.to.x - offset.from.x,
                1,
            );
        }
    }

    _AliasedPolygon4Points__Calc(
        color_id_str, color_id_int, x_0, y_0, x_1, y_1, x_2, y_2, x_3, y_3, from_x, from_y, to_x, to_y
    ) {
        let buffer = document.createElement('canvas');
        buffer.height = Math.round(to_y - from_y + 0.5);
        buffer.width  = Math.round(to_x - from_x + 0.5);

        let buffer_context = buffer.getContext('2d');
        buffer_context.clearRect(0, 0, buffer.width, buffer.height);

        buffer_context.fillStyle = color_id_str;
        buffer_context.strokeStyle = color_id_str;

        let d_x_0 = Math.round(x_0 - from_x + 1.5);
        let d_y_0 = Math.round(y_0 - from_y + 1.5);
        let d_x_1 = Math.round(x_1 - from_x + 1.5);
        let d_y_1 = Math.round(y_1 - from_y + 1.5);
        let d_x_2 = Math.round(x_2 - from_x + 1.5);
        let d_y_2 = Math.round(y_2 - from_y + 1.5);
        let d_x_3 = Math.round(x_3 - from_x + 1.5);
        let d_y_3 = Math.round(y_3 - from_y + 1.5);

        buffer_context.beginPath();
        buffer_context.moveTo(d_x_0, d_y_0);
        buffer_context.lineTo(d_x_1, d_y_1);
        buffer_context.lineTo(d_x_2, d_y_2);
        buffer_context.lineTo(d_x_3, d_y_3);
        buffer_context.lineTo(d_x_0, d_y_0);
        buffer_context.closePath();
        buffer_context.fill();

        let offsets = [];
        let from_offset = null;
        let row_length = buffer.width * 4;

        let image_data = buffer_context.getImageData(0, 0, buffer.width, buffer.height);
        for (let i = 0; i < image_data.data.length; i += 4) {
            let r_offset = i;
            let g_offset = i + 1;
            let b_offset = i + 2;
            let a_offset = i + 3;

            let x = i % row_length;
            let y = (i - x) / buffer.width / 4;
            x /= 4;

            let target = parseInt(
                  image_data.data[r_offset].toString(16).padStart(2, '0')
                + image_data.data[g_offset].toString(16).padStart(2, '0')
                + image_data.data[b_offset].toString(16).padStart(2, '0')
                + image_data.data[a_offset].toString(16).padStart(2, '0'),
                16,
            );

            if (color_id_int == target) {
                if (from_offset == null) {
                    from_offset = { 'x': x, 'y': y };
                }
            } else {
                if (from_offset != null) {
                    offsets.push({
                        'from': from_offset,
                        'to': { 'x': x, 'y': y },
                    })
                    from_offset = null;
                }
            }

            if (x == buffer.width - 1) {
                if (from_offset != null) {
                    offsets.push({
                        'from': from_offset,
                        'to': { 'x': x, 'y': y },
                    })
                    from_offset = null;
                }
            }
        }

        return offsets
    }

    _DistanceBetweenTwoPoints(from_x, from_y, to_x, to_y) {
        return Math.abs(Math.sqrt(
            Math.pow(from_x - to_x, 2)
          + Math.pow(from_y - to_y, 2)
        ));
    }

    _Round(number, decimals = 1) {
        let factor = Math.pow(10, decimals);
        return Math.round(number * factor) / factor;
    }

    _Message(title, message, silent=false) {
        // console.log(`${title}: ${message}`);

        if (silent) return;

        try {
            this._callback_message(title, message);

        } catch (error) {
            console.error('_Message', {'title': title, 'message': message}, error);
        }
    }
}

class LaggerMapEditRacksPopup {
    // State
    _entity = null;
    _selected_node = null;
    _gate_coordinates = null;
    _labels = null;

    _padding_x = 25;
    _padding_y = 25;

    // Dom
    _dialog = null;
    _canvas = null;
    _user_input = null;

    // Offscreen canvas
    _offscreen_canvas_pos = null;
    _offscreen_canvas_detected_selected_node = null;

    // callback
    _update_callback = null;

    constructor(dialog, entity, update_callback) {
        if (entity?.type != EntitieTypes.POSITION) throw 'The entity is not of type EntitieTypes.POSITION';

        this._dialog = dialog;
        this._entity = entity;

        this._update_callback = update_callback;

        this._canvas = document.createElement('canvas');
        this._offscreen_canvas_detected_selected_node = document.createElement('canvas');
        this._offscreen_canvas_pos = document.createElement('canvas');

        this._gate_coordinates = [];
        this._labels = [];

        for (let i = 0; i < entity.args.racks_data.length; i++) {
            this._labels[i] = entity.args.racks_data[i];
        }

        this._SetupDialog();
    }

    _Draw() {
        let context = this._canvas.getContext('2d');
        context.clearRect(0, 0, this._canvas.width, this._canvas.height);

        context.drawImage(this._offscreen_canvas_pos, 0, 0, this._canvas.width, this._canvas.height);

        this._DrawPosLabels(context);
    }

    _DrawPosLabels(context) {
        context.save();

        context.font = `${LAGER_MAP_REOL_FONT_SIZE * 2}px ${LAGER_MAP_FONT}`;
        context.textBaseline = 'top';

        for (let i = 0; i < this._labels.length; i++) {
            let text = this._labels[i];
            let width = context.measureText(text).width;
            let coordinates = this._gate_coordinates[i];

            context.fillStyle = '#f50';
            context.fillRect(coordinates.x, coordinates.y, width + 2, parseInt(LAGER_MAP_REOL_FONT_SIZE * 2, 10));

            context.fillStyle = '#000';
            context.fillText(text, coordinates.x, coordinates.y + 2);
        }

        context.restore();
    }

    _SetupDialog() {
        let container = document.createElement('div');
        container.style.width = 'fit-content';
        container.style.minWidth = '576px';
        container.style.maxWidth = '768px';
        container.style.background = 'white';
        container.style.borderRadius = '10px';
        container.style.overflow = 'hidden';
        container.style.color = '#606060';
        container.style.position = 'relative';

        this._dialog.innerHTML = '';
        this._dialog.appendChild(container);

        let top = document.createElement('div');
        container.appendChild(top);
        top.style.display = 'flex';
        top.style.padding = '30px 30px 15px';
        top.style.justifyContent = 'space-between';

        let titel = document.createElement('div');
        let id = this._entity.args.aisle || '';
        titel.innerText = `Aisle: ${id ? !isNaN(id) ? `${id}` : `"${id}"` : '{NOT SET}'}`;
        titel.style.fontSize = '1.222rem';
        titel.style.fontWeight = '600';
        top.appendChild(titel);

        let top_menu = document.createElement('div');
        top.append(top_menu);

        // Save
        let save_btn = document.createElement('button');
        save_btn.className = 'icon apply';
        //save_btn.style.marginTop = '30px';
        save_btn.style.width = '34px';
        save_btn.style.height = '34px';
        save_btn.style.border = '0';
        save_btn.style.outline = '0';
        save_btn.style.background = '#58bf5d';
        save_btn.title = 'Apply';
        save_btn.onclick = (event) => {
            event.preventDefault();
            this._entity.args.racks_data = this._labels;
            this._dialog.close();
            if (this._user_input) this._user_input.remove();
            this._update_callback();
        };
        top_menu.appendChild(save_btn);

        // Discard
        let discard_btn = document.createElement('button');
        discard_btn.className = 'icon close';
        //discard_btn.style.marginTop = '30px';
        discard_btn.style.marginLeft = '30px';
        discard_btn.style.width = '34px';
        discard_btn.style.height = '34px';
        discard_btn.style.border = '0';
        discard_btn.style.outline = '0';
        discard_btn.style.background = '#ff686e';
        discard_btn.title = 'Discard';
        discard_btn.onclick = (event) => {
            event.preventDefault();
            this._dialog.close();
            if (this._user_input) this._user_input.remove();
        };
        top_menu.appendChild(discard_btn);

        this._dialog.show();
        
        
        let container_controls = document.createElement('div');
        let container_width = container.getBoundingClientRect().width + 'px';
        let top_height = top.getBoundingClientRect().height + 'px';
        container.appendChild(container_controls);
        container_controls.appendChild(this._canvas);
        //container_controls.style.width = container_width;
        container_controls.style.height = `calc(100% - ${top_height})`;
        container_controls.style.maxHeight = container_width;
        container_controls.style.paddingBottom = '10px';
        container_controls.style.position = 'relative';
        container_controls.style.overflow = 'auto';

        this._SetupDialog__Controls(100);

        let container_controls_bounding_client_rect = container_controls.getBoundingClientRect();

        this._canvas.width = this._offscreen_canvas_pos.width;
        this._canvas.height = this._offscreen_canvas_pos.height;

        if (this._canvas.width < container_controls_bounding_client_rect.width) {
            let width_delta = container_controls_bounding_client_rect.width - this._canvas.width;
            width_delta /= 2;
            this._canvas.style.marginLeft = `${width_delta + 100}px`;
        }

        this._Draw();

        this._canvas.onmousedown = (event) => this._CanvasOnclick(event);
    }

    _SetupDialog__Controls(min_width) {
        let width = this._entity.args.width;
        let height = this._entity.args.length;

        if (width < min_width) {
            let factor = min_width / this._entity.args.width
            width *= factor;
            height *= factor;
        }

        let offset_width = width / 2;
        let offset_height = height / 2;

        let cosθ = Math.cos(this._entity.args.angle * (Math.PI / 180));
        let sinθ = Math.sin(this._entity.args.angle * (Math.PI / 180));

        // Box
        let x_0 = -offset_width;
        let y_0 = -offset_height;

        let x_1 = width - offset_width;
        let y_1 = -offset_height;

        let x_2 = width - offset_width;
        let y_2 = height - offset_height;

        let x_3 = -offset_width;
        let y_3 = height - offset_height;

        // X_new = X_old x cos_θ – Y_old * sin_θ
        // Y_new = X_old x sin_θ + Y_old * cos_θ

        let x_0_θ = (x_0 * cosθ) - (y_0 * sinθ) + offset_width;
        let y_0_θ = (x_0 * sinθ) + (y_0 * cosθ) + offset_height;

        let x_1_θ = (x_1 * cosθ) - (y_1 * sinθ) + offset_width;
        let y_1_θ = (x_1 * sinθ) + (y_1 * cosθ) + offset_height;

        let x_2_θ = (x_2 * cosθ) - (y_2 * sinθ) + offset_width;
        let y_2_θ = (x_2 * sinθ) + (y_2 * cosθ) + offset_height;

        let x_3_θ = (x_3 * cosθ) - (y_3 * sinθ) + offset_width;
        let y_3_θ = (x_3 * sinθ) + (y_3 * cosθ) + offset_height;

        let min_x = Math.min(x_0_θ, x_1_θ, x_2_θ, x_3_θ);
        if (min_x < 0) {
            min_x = Math.abs(min_x);
            x_0_θ += min_x;
            x_1_θ += min_x;
            x_2_θ += min_x;
            x_3_θ += min_x;
        } else {
            min_x = 0;
        }
        let min_y = Math.min(y_0_θ, y_1_θ, y_2_θ, y_3_θ);
        if (min_y < 0) {
            min_y = Math.abs(min_y);
            y_0_θ += min_y;
            y_1_θ += min_y;
            y_2_θ += min_y;
            y_3_θ += min_y;
        } else {
            min_y = 0;
        }

        let padding_x_pos = this._padding_x / 2;
        let padding_y_pos = this._padding_y / 2;
        x_0_θ += padding_x_pos;
        x_1_θ += padding_x_pos;
        x_2_θ += padding_x_pos;
        x_3_θ += padding_x_pos;
        y_0_θ += padding_y_pos;
        y_1_θ += padding_y_pos;
        y_2_θ += padding_y_pos;
        y_3_θ += padding_y_pos;

        x_0_θ = parseInt(x_0_θ);
        x_1_θ = parseInt(x_1_θ);
        x_2_θ = parseInt(x_2_θ);
        x_3_θ = parseInt(x_3_θ);
        y_0_θ = parseInt(y_0_θ);
        y_1_θ = parseInt(y_1_θ);
        y_2_θ = parseInt(y_2_θ);
        y_3_θ = parseInt(y_3_θ);

        let canvas_width  = Math.max(x_0_θ, x_1_θ, x_2_θ, x_3_θ) + 200;
        let canvas_height = Math.max(y_0_θ, y_1_θ, y_2_θ, y_3_θ);

        this._offscreen_canvas_pos.width  = parseInt(canvas_width + padding_x_pos);
        this._offscreen_canvas_pos.height = parseInt(canvas_height + padding_y_pos);
        let context = this._offscreen_canvas_pos.getContext('2d');
        context.clearRect(0, 0, this._offscreen_canvas_pos.width, this._offscreen_canvas_pos.height);

        context.lineWidth = LAGER_MAP_WALL_WIDTH;
        context.lineStyle = LAGER_MAP_REOL_LINE_STYLE;
        context.fillStyle = LAGER_MAP_REOL_FILL_STYLE;

        context.beginPath();
        context.moveTo(x_0_θ, y_0_θ);
        context.lineTo(x_1_θ, y_1_θ);
        context.lineTo(x_2_θ, y_2_θ);
        context.lineTo(x_3_θ, y_3_θ);
        context.lineTo(x_0_θ, y_0_θ);
        context.closePath();

        context.stroke();
        context.fill();

        this._offscreen_canvas_detected_selected_node.width = this._offscreen_canvas_pos.width;
        this._offscreen_canvas_detected_selected_node.height = this._offscreen_canvas_pos.height;
        let context_id = this._offscreen_canvas_detected_selected_node.getContext('2d');
        context_id.clearRect(0, 0, this._offscreen_canvas_pos.width, this._offscreen_canvas_pos.height);

        context_id.rect(0, 0, this._offscreen_canvas_detected_selected_node.width, this._offscreen_canvas_detected_selected_node.height);
        context_id.fillStyle = '#FFFFFFFF';
        context_id.fill();

        context.fillStyle = LAGER_MAP_REOL_GATE_FILL_STYLE;

        let separate_gap = height / this._entity.args.racks;
        let separate_gap_half = separate_gap / 2;
        for (let i = 0; i < this._entity.args.racks; i++) {
            // Separate and gate
            let separate_x_0 = -offset_width;
            let separate_y_0 = -offset_height + (separate_gap * i);
            let separate_x_1 = offset_width;
            let separate_y_1 = separate_y_0;

            let separate_x_0_θ = parseInt(
                (separate_x_0 * cosθ)
                - (separate_y_0 * sinθ)
                + offset_width
                + padding_x_pos
                + min_x
            );
            let separate_y_0_θ = parseInt(
                (separate_x_0 * sinθ)
                + (separate_y_0 * cosθ)
                + offset_height
                + padding_y_pos
                + min_y
            );

            let separate_x_1_θ = parseInt(
                (separate_x_1 * cosθ)
                - (separate_y_1 * sinθ)
                + offset_width
                + padding_x_pos
                + min_x
            );
            let separate_y_1_θ = parseInt(
                (separate_x_1 * sinθ)
                + (separate_y_1 * cosθ)
                + offset_height
                + padding_y_pos
                + min_y
            );

            if (i != 0) {
                context.beginPath();
                context.moveTo(separate_x_0_θ, separate_y_0_θ);
                context.lineTo(separate_x_1_θ, separate_y_1_θ);
                context.stroke();
            }

            let separate_gate_x_θ = parseInt(
                (separate_x_0 * cosθ)
                - ((separate_y_0 + separate_gap_half) * sinθ)
                + offset_width
                + padding_x_pos
                + min_x
            );
            let separate_gate_y_θ = parseInt(
                (separate_x_0 * sinθ)
                + ((separate_y_0 + separate_gap_half) * cosθ)
                + offset_height
                + padding_y_pos
                + min_y
            );

            context.beginPath();
            context.arc(separate_gate_x_θ, separate_gate_y_θ, LAGER_MAP_REOL_GATE_SIZE, 0, Math.PI * 2);
            this._gate_coordinates[i] = { 'x': separate_gate_x_θ, 'y': separate_gate_y_θ };
            context.fill();
            context.stroke();

            // Color id
            let separate_x_0_end = -offset_width;
            let separate_y_0_end = -offset_height + (separate_gap * (i + 1));
            let separate_x_1_end = offset_width;
            let separate_y_1_end = separate_y_0_end;

            let separate_x_0_θ_end = parseInt(
                (separate_x_0_end * cosθ)
                - (separate_y_0_end * sinθ)
                + offset_width
                + padding_x_pos
                + min_x
            );
            let separate_y_0_θ_end = parseInt(
                (separate_x_0_end * sinθ)
                + (separate_y_0_end * cosθ)
                + offset_height
                + padding_y_pos
                + min_y
            );

            let separate_x_1_θ_end = parseInt(
                (separate_x_1_end * cosθ)
                - (separate_y_1_end * sinθ)
                + offset_width
                + padding_x_pos
                + min_x
            );
            let separate_y_1_θ_end = parseInt(
                (separate_x_1_end * sinθ)
                + (separate_y_1_end * cosθ)
                + offset_height
                + padding_y_pos
                + min_y
            );

            let color_id = '#' + (i).toString(16).padStart(6, '0') + 'FF';
            context_id.beginPath();
            this._AliasedPolygon4Points(
                context_id,
                separate_x_0_θ, separate_y_0_θ,
                separate_x_1_θ, separate_y_1_θ,
                separate_x_1_θ_end, separate_y_1_θ_end,
                separate_x_0_θ_end, separate_y_0_θ_end,
            );
            context_id.fillStyle = color_id;
            context_id.strokeStyle = color_id;
            context_id.fill();
        }
    }

    _AliasedPolygon4Points(ctx, x_0, y_0, x_1, y_1, x_2, y_2, x_3, y_3) {  // NOTE: for fill only!
        let color_id_str = '#AAAAAAFF';
        let color_id_int = parseInt('AAAAAAFF', 16);

        let buffer = document.createElement('canvas');

        let from_x = Math.min(x_0, x_1, x_2, x_3);
        let from_y = Math.min(y_0, y_1, y_2, y_3);
        let to_x   = Math.max(x_0, x_1, x_2, x_3);
        let to_y   = Math.max(y_0, y_1, y_2, y_3);

        buffer.height = Math.round(to_y - from_y + 1);
        buffer.width  = Math.round(to_x - from_x + 1);

        let buffer_context = buffer.getContext('2d');
        buffer_context.clearRect(0, 0, buffer.width, buffer.height);

        buffer_context.fillStyle = color_id_str;
        buffer_context.strokeStyle = color_id_str;

        let d_x_0 = Math.round(x_0 - from_x);
        let d_y_0 = Math.round(y_0 - from_y);
        let d_x_1 = Math.round(x_1 - from_x);
        let d_y_1 = Math.round(y_1 - from_y);
        let d_x_2 = Math.round(x_2 - from_x);
        let d_y_2 = Math.round(y_2 - from_y);
        let d_x_3 = Math.round(x_3 - from_x);
        let d_y_3 = Math.round(y_3 - from_y);

        buffer_context.beginPath();
        buffer_context.moveTo(d_x_0 , d_y_0);
        buffer_context.lineTo(d_x_1 , d_y_1);
        buffer_context.lineTo(d_x_2 , d_y_2);
        buffer_context.lineTo(d_x_3 , d_y_3);
        buffer_context.lineTo(d_x_0 , d_y_0);
        buffer_context.closePath();
        buffer_context.fill();

        let offsets = [];
        let from_offset = null;
        let row_length = buffer.width * 4;

        let image_data = buffer_context.getImageData(0, 0, buffer.width, buffer.height);
        for (let i = 0; i < image_data.data.length; i += 4) {
            let r_offset = i;
            let g_offset = i + 1;
            let b_offset = i + 2;
            let a_offset = i + 3;

            let x = i % row_length;
            let y = (i - x) / buffer.width / 4;
            x /= 4;

            let target = parseInt(
                  image_data.data[r_offset].toString(16).padStart(2, '0')
                + image_data.data[g_offset].toString(16).padStart(2, '0')
                + image_data.data[b_offset].toString(16).padStart(2, '0')
                + image_data.data[a_offset].toString(16).padStart(2, '0'),
                16,
            );

            if (color_id_int == target) {
                if (from_offset == null) {
                    from_offset = { 'x': x, 'y': y };
                }
            } else {
                if (from_offset != null) {
                    offsets.push({
                        'from': from_offset,
                        'to': { 'x': x, 'y': y },
                    })
                    from_offset = null;
                }
            }

            if (x == buffer.width - 1) {
                if (from_offset != null) {
                    offsets.push({
                        'from': from_offset,
                        'to': { 'x': x, 'y': y },
                    })
                    from_offset = null;
                }
            }
        }

        let from_x_base = Math.round(from_x);
        let from_y_base = Math.round(from_y);
        for (let i = 0; i < offsets.length; i++) {
            let offset = offsets[i];
            ctx.rect(
                offset.from.x + from_x_base,
                offset.from.y + from_y_base,
                offset.to.x - offset.from.x,
                1,
            );
        }
    }

    _CanvasOnclick(event) {
        event.preventDefault();
        
        if (event.button) return;

        let rect = this._canvas.getBoundingClientRect();
        let args = {
            'event': event,
            'x': event.clientX - rect.left,
            'y': event.clientY - rect.top,
            'coords': this._gate_coordinates
        };

        let context = this._offscreen_canvas_detected_selected_node.getContext('2d');
        let pixel = context.getImageData(args.x, args.y, 1, 1).data;

        let event_target = parseInt(
              pixel[0].toString(16).padStart(2, '0')
            + pixel[1].toString(16).padStart(2, '0')
            + pixel[2].toString(16).padStart(2, '0'),
            16
        );

        args.entity_id = event_target != 0xFFFFFF ? event_target : null;
        this._CanvasOnclick__ProcessEvent(args);
    }

    _CanvasOnclick__ProcessEvent(args) {
        // console.debug(args);

        const _RemoveUserInput = () => {
            if (this._user_input) {
                this._user_input.remove();
                this._user_input = null;
            }
        }
        
        if (args.entity_id == null) {
            _RemoveUserInput();
            return;
        }

        _RemoveUserInput();

        //if (this._selected_node == args.entity_id) return;
        this._selected_node = args.entity_id;
        let label = this._labels[args.entity_id];
        let coords = args.coords[args.entity_id] || {};
        let marginLeft = parseInt(this._canvas.style.marginLeft || 0);

        this._user_input = document.createElement('span');
        this._user_input.setAttribute('spellcheck', false);
        this._user_input.setAttribute('contenteditable', true);
        this._user_input.textContent = label;
        this._user_input.style.top = `${coords.y}px`;
        this._user_input.style.left = `${marginLeft + coords.x}px`;
        this._user_input.style.position = 'absolute';
        this._user_input.style.background = '#ff5500';
        this._user_input.style.borderRadius = 'none';
        this._user_input.style.outline = 'none';
        this._user_input.style.border = '0';
        this._user_input.style.zIndex = '3';
        this._user_input.style.lineHeight = '1';
        this._user_input.style.minWidth = '2px';
        this._user_input.style.color = '#000000';
        this._user_input.style.fontFamily = LAGER_MAP_FONT;
        this._user_input.style.fontSize = (LAGER_MAP_REOL_FONT_SIZE * 2) + 'px';
        this._user_input.style.height = parseInt(LAGER_MAP_REOL_FONT_SIZE * 2, 10) + 'px';

        this._user_input.oninput = () => {
            this._labels[args.entity_id] = this._user_input.textContent;
            this._Draw();
        }

        this._user_input.onkeydown = (event) => {
            if (event.keyCode == 13) this._user_input.blur();
            else if (event.keyCode != 27) return;
            _RemoveUserInput();
        };

        this._canvas.parentElement.appendChild(this._user_input);

        this._user_input.focus();

        // Set caret at end of text and select
        let contenteditable = this._user_input;
        let selection = window.getSelection();
        let range = document.createRange();
        if ((contenteditable.lastChild || {}).nodeType == 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length);
        } else {
            range.setStart(contenteditable, contenteditable.childNodes.length);
        }
        range.selectNodeContents(contenteditable);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

class PickPath {
    map_wall; // 2D array[y][x] of booleans where true is a wall 
    start;
    entities;
    uint_size_m;
    position_to_x_and_y;
    path;

    constructor(uint_size_m, entities, path_data) {
        this.uint_size_m = uint_size_m;
        this.entities = entities;
        this.position_to_x_and_y = new Map();
        this.path = [];

        this.map_wall = [];
        this._MapInit();

        let walls = [];
        let position = [];

        Object.entries(this.entities).forEach(x => {
            let entity = x[1];
            switch (entity?.type) {
                case EntitieTypes.WALL: 
                    walls.push(entity); 
                    break;
                
                case EntitieTypes.POSITION: 
                    position.push(entity); 
                    break;

                case EntitieTypes.START: 
                    this.start = {x: entity.x, y: entity.y}; 
                    break;
            }
        });

        this._MapWalls(walls);
        this._MapPosition(position);
        this._CalcPaths(Array.from(path_data));
    }

    get Result() { return this.path; }

    _MapInit() {
        let map_row = [];
        for (let i = 0; i < LAGER_MAP_CANVAS_HEIGHT; i++) map_row.push(false);

        for (let i = 0; i < LAGER_MAP_CANVAS_WIDTH; i++) {
            this.map_wall.push([...map_row]);
        }
    }

    _MapWalls(walls) {
        let wall_offset = Math.ceil(0.05 / this.uint_size_m);
        let connect_walls_within = Math.ceil(0.25 / this.uint_size_m);
        
        walls.forEach(wall => {
            for (let {x, y} of BresenhamLine(
                wall.x,
                wall.y,
                wall.args.to.x,
                wall.args.to.y,
            )) {
                this._FillWallAt(x, y, wall_offset);
            }

            for (let {x, y} of AliasedCircle(wall.x, wall.y, connect_walls_within)) this.map_wall[y][x] = true;
            for (let {x, y} of AliasedCircle(wall.args.to.x, wall.args.to.y, connect_walls_within)) this.map_wall[y][x] = true;
        });
    }

    _MapPosition(positions) {
        let gate_buffer = Math.round(0.1 / this.uint_size_m);

        for (let item of positions) {
            let position_x_and_y = this.position_to_x_and_y.get(item.args.aisle);
            if (!position_x_and_y) {
                position_x_and_y = new Map();
                this.position_to_x_and_y.set(item.args.aisle, position_x_and_y);
            }

            let delta_width = item.args.width / this.uint_size_m;
            let delta_height = item.args.length / this.uint_size_m;

            let offset_width = delta_width / 2;
            let offset_height = delta_height / 2;

            let cosθ = Math.cos(item.args.angle * (Math.PI / 180));
            let sinθ = Math.sin(item.args.angle * (Math.PI / 180));

            // Box
            let x_0 = -offset_width;
            let y_0 = -offset_height;

            let x_1 = delta_width - offset_width;
            let y_1 = -offset_height;

            let x_2 = delta_width - offset_width;
            let y_2 = delta_height - offset_height;

            let x_3 = -offset_width;
            let y_3 = delta_height - offset_height;

            let x_0_θ = Math.round((x_0 * cosθ) - (y_0 * sinθ) + item.x);
            let y_0_θ = Math.round((x_0 * sinθ) + (y_0 * cosθ) + item.y);

            let x_1_θ = Math.round((x_1 * cosθ) - (y_1 * sinθ) + item.x);
            let y_1_θ = Math.round((x_1 * sinθ) + (y_1 * cosθ) + item.y);

            let x_2_θ = Math.round((x_2 * cosθ) - (y_2 * sinθ) + item.x);
            let y_2_θ = Math.round((x_2 * sinθ) + (y_2 * cosθ) + item.y);

            let x_3_θ = Math.round((x_3 * cosθ) - (y_3 * sinθ) + item.x);
            let y_3_θ = Math.round((x_3 * sinθ) + (y_3 * cosθ) + item.y);

            for (let {x, y} of BresenhamLine(x_0_θ, y_0_θ, x_1_θ, y_1_θ)) this._FillWallAt(x, y, gate_buffer);
            for (let {x, y} of BresenhamLine(x_1_θ, y_1_θ, x_2_θ, y_2_θ)) this._FillWallAt(x, y, gate_buffer);
            for (let {x, y} of BresenhamLine(x_2_θ, y_2_θ, x_3_θ, y_3_θ)) this._FillWallAt(x, y, gate_buffer);
            for (let {x, y} of BresenhamLine(x_3_θ, y_3_θ, x_0_θ, y_0_θ)) this._FillWallAt(x, y, gate_buffer);

            for (let {x, y} of AliasedCircle(x_0_θ, y_0_θ, 3)) this.map_wall[y][x] = true;
            for (let {x, y} of AliasedCircle(x_1_θ, y_1_θ, 3)) this.map_wall[y][x] = true;
            for (let {x, y} of AliasedCircle(x_2_θ, y_2_θ, 3)) this.map_wall[y][x] = true;
            for (let {x, y} of AliasedCircle(x_3_θ, y_3_θ, 3)) this.map_wall[y][x] = true;

            // Separate and gate
            let separate_gap = item.args.length / this.uint_size_m / item.args.racks;
            let separate_gap_half = separate_gap / 2;

            for (let i = 0; i < item.args.racks; i++) {
                let separate_x_0 = -offset_width - gate_buffer;
                let separate_y_0 = -offset_height + (separate_gap * i);

                // for (let {x, y} of AliasedCircle(
                //     Math.round((separate_x_0 * cosθ) - ((separate_y_0 + separate_gap_half) * sinθ) + item.x),
                //     Math.round((separate_x_0 * sinθ) + ((separate_y_0 + separate_gap_half) * cosθ) + item.y),
                //     gate_buffer,
                // )) this.map_wall[y][x] = true;
                
                separate_x_0 -= Math.round(gate_buffer / 2) + 5;
                
                position_x_and_y.set(String(item.args.racks_data[i]), {
                    x: Math.round((separate_x_0 * cosθ) - ((separate_y_0 + separate_gap_half) * sinθ) + item.x),
                    y: Math.round((separate_x_0 * sinθ) + ((separate_y_0 + separate_gap_half) * cosθ) + item.y),
                });
            }
        }

    }

    _FillWallAt(x, y, wall_offset) {
        let start_x = x - wall_offset;
        if (start_x < 0) start_x = 0;

        let start_y = y - wall_offset
        if (start_y < 0) start_y = 0;

        let end_x = x + wall_offset;
        if (end_x > LAGER_MAP_CANVAS_HEIGHT - 1) end_x = LAGER_MAP_CANVAS_HEIGHT - 1;

        let end_y = y + wall_offset;
        if (end_y > LAGER_MAP_CANVAS_WIDTH - 1) end_y = LAGER_MAP_CANVAS_WIDTH - 1;

        let at_x = start_x;
        let at_y = start_y;
        while (at_x <= end_x && at_y <= end_y) {
            this.map_wall[at_y][at_x] = true;

            at_x++;
            if (at_x > end_x) {
                at_x = start_x;
                at_y++;
            }
        }
    }

    _CalcPaths(path_data) {
        let map_path = new Array(LAGER_MAP_CANVAS_HEIGHT);
        for (let y = 0; y < LAGER_MAP_CANVAS_HEIGHT; y++) {
            map_path[y] = new Array(LAGER_MAP_CANVAS_WIDTH);
        }

        let previous_node = {x: this.start.x, y: this.start.y, r: 'start', h: ''};
        
        for (let target of path_data) {
            let target_node = this.position_to_x_and_y.get(target.r)?.get(target.h);
            if (!target_node) {
                this.path.push({type: 'skip', r: target.r, h: target.h})
                continue;
            }

            console.debug(previous_node, '->', target_node);
            let result = {
                type: 'path',
                from: previous_node,
                to: {x: target_node.x, y: target_node.y, r: target.r, h: target.h},
                path: this._CalcPaths__Helper(
                    map_path,
                    previous_node.x,
                    previous_node.y,
                    target_node.x,
                    target_node.y,
                    this.map_wall,
                ),
            };

            this.path.push(result);
            previous_node = result.to;
        }

        console.debug(previous_node, '->', this.start);
        this.path.push({
            type: 'path',
            from: previous_node,
            to: {x: this.start.x, y: this.start.y, r: 'end', h: ''},
            path: this._CalcPaths__Helper(
                map_path,
                previous_node.x,
                previous_node.y,
                this.start.x,
                this.start.y,
            ),
        });

        console.debug('DONE');
    }

    _CalcPaths__Helper(
        map_path,
        from_x,
        from_y,
        to_x,
        to_y,
    ) {
        // use this function reverse optimization result 
        let first = new Astar(
            map_path,
            from_x,
            from_y,
            to_x,
            to_y,
            this.map_wall,
        ).Path();

        if (first.length < 100) return first;

        let mid = first[Math.floor(first.length /2)];

        let start = new Astar(
            map_path,
            from_x,
            from_y,
            mid.x,
            mid.y,
            this.map_wall,
        ).Path();
        start.pop();

        let end = new Astar(
            map_path,
            mid.x,
            mid.y,
            to_x,
            to_y,
            this.map_wall,
        ).Path();

        return start.concat(end);
    }
}


/**
 * @param {number} x
 * @param {number} y
 */
function CheckIfInRangeOfCanvas(
    x,
    y
) {
    return x >= 0 && 
           y >= 0 && 
           x < LAGER_MAP_CANVAS_WIDTH &&
           y < LAGER_MAP_CANVAS_HEIGHT;
}

/**
 * @see: https://en.wikipedia.org/wiki/Bresenham%27s_line_algorithm
 * 
 * Yield integer coordinates on the line from (x0, y0) to (x1, y1).
 * Input coordinates should be integers.
 * The result will contain both the start and the end point.
 * 
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 */
function *BresenhamLine(x0, y0, x1, y1) {
    let dx = x1 - x0;
    let dy = y1 - y0;

    let xsign = dx > 0 ? 1 : -1;
    let ysign = dy > 0 ? 1 : -1;

    dx = Math.abs(dx);
    dy = Math.abs(dy);

    let xx = xsign;
    let xy = 0;
    let yx = 0
    let yy = ysign;

    if (dx < dy) {
        let tmp = dy;
        dy = dx;
        dx = tmp;

        xx = 0;
        xy = ysign;
        yx = xsign;
        yy = 0;
    }

    let D = 2 * dy - dx;
    let y = 0;

    for (let x = 0; x <= dx; x++) {
        let result_x = x0 + x * xx + y * yx;
        let result_y = y0 + x * xy + y * yy;
        if (CheckIfInRangeOfCanvas(result_x, result_y)) {
            yield {x: result_x, y: result_y};
        }

        if (D >= 0) {
            y += 1;
            D -= 2 * dx;

            yield {x: x0 + x * xx + y * yx, y: result_y};
            yield {x: result_x, y: y0 + x * xy + y * yy};
        }

        D += 2 * dy;
    }
}

function *AliasedCircle(xc, yc, r) {
    for (let x = -r; x < r; x++)  {
        let result_x = xc + x;
        if (CheckIfInRangeOfCanvas(result_x, yc)) {
            yield {x: result_x, y: yc};
        }
    }

    let x = r, y = 0, cd = 0;
    while (x > y) {
        cd -= (--x) - (++y);
        if (cd < 0) cd += x++;
        
        for (let item of [
            { x: xc - y, y: yc - x, l: y<<1 },
            { x: xc - x, y: yc - y, l: x<<1 },
            { x: xc - x, y: yc + y, l: x<<1 },
            { x: xc - y, y: yc + x, l: y<<1 },
        ]) {
            for (let i = 0; i <= item.l; i++) {
                if (CheckIfInRangeOfCanvas(item.x, item.y)) {
                    yield {x: item.x + i, y: item.y};
                }
            }
        }
    }
}

class Astar {
    map_wall; // 2D array[y][x] of booleans where true is a wall -- only use as readonly
    map_path; // 2D array[y][x] of booleans of AstarNode

    // start and end is {x, y}
    start_node; // starting point
    end_node; // ending point (goal)

    open_nodes; // set of open nodes

    reset_list;

    /**
     * @param {Array} map_path
     * @param {number} start_x 
     * @param {number} start_y 
     * @param {number} end_x 
     * @param {number} end_y 
     * @param {Array} map_wall 
     */
    constructor(
        map_path,
        start_x,
        start_y,
        end_x,
        end_y,
        map_wall,
    ) {
        this.map_wall = map_wall;
        this.map_path = map_path;

        this.reset_list = [];

        this.start_node = {x: start_x, y: start_y};
        this.end_node = {x: end_x, y: end_y};

        this.open_nodes = new AstarNodeSet();

        let start_node = map_path[start_y][start_x];
        if (!start_node) {
            start_node = new AstarNode(start_x, start_y);
            map_path[start_y][start_x] = start_node;
        }

        start_node.Update(start_x, start_y, end_x, end_y);
        this.open_nodes.add(start_node);
        this.reset_list.push(start_node);

        this._MainLoop();
        this._Reset();
    }

    _Reset() {
        for (let i = 0; i < this.reset_list.length; i++) {
            this.reset_list[i].Reset();
        }
    }

    _MainLoop() {
        while (this.open_nodes.size > 0) {
            let target_node = this.open_nodes.pop();

            for (let {x, y} of this._Neighbors(target_node.x, target_node.y)) {
                if (this.map_wall[y][x]) continue;
                let node = this.map_path[y][x];
                if (!node) {
                    node = new AstarNode(x, y);
                    this.map_path[y][x] = node;
                }

                if (!node.IsSet) {
                    this.reset_list.push(node);
                    node.Update(
                        this.start_node.x, this.start_node.y, 
                        this.end_node.x, this.end_node.y, 
                        target_node,
                    );
                    this.open_nodes.add(node);
                } else {
                    node.SetParentIfDistanceLess(target_node);
                }
            }

            if (target_node.x == this.end_node.x && target_node.y == this.end_node.y) break;
        }
    }

    _Neighbors(target_x, target_y) {
        let neighbors = [
            {x: target_x,     y: target_y + 1}, // N
            {x: target_x + 1, y: target_y + 1}, // NE
            {x: target_x + 1, y: target_y    }, // E
            {x: target_x + 1, y: target_y - 1}, // SE
            {x: target_x,     y: target_y - 1}, // S
            {x: target_x - 1, y: target_y - 1}, // WS
            {x: target_x - 1, y: target_y    }, // W
            {x: target_x - 1, y: target_y + 1}, // NW
        ];

        if (target_x <= 0 || 
            target_y <= 0 || 
            target_x >= LAGER_MAP_CANVAS_HEIGHT - 1 || 
            target_y >= LAGER_MAP_CANVAS_WIDTH - 1
        ) {
            let buffer = [];
            for (let item of neighbors) {
                if (
                    item.x < 0 || 
                    item.x >= LAGER_MAP_CANVAS_HEIGHT ||
                    item.y < 0 || 
                    item.y >= LAGER_MAP_CANVAS_WIDTH
                ) continue;
                    
                buffer.append(item);
            }

            return buffer;
        } else {
            return neighbors;
        }
    }

    Path() {
        let at = this.map_path[this.end_node.y][this.end_node.x];
        if (!at) throw new Error(
            `There is no path found -- (${this.start_node.x}, ${this.start_node.y}) -> (${this.end_node.x}, ${this.end_node.y})`
        );

        let result = [{x: at.x, y: at.y}];

        while (at.parent) {
            at = at.parent;
            result.push({x: at.x, y: at.y});
        }

        return result.reverse();
    }
}

class AstarNode {
    flag;
    x; // x location of the grid point
    y; // y location of the grid point

    f; // total cost function
    g; // cost function from start to the current grid point
    h; // heuristic estimated cost function from current grid point to the goal

    parent; // immediate source of the current grid point

    distance;
    hash; 

    constructor(x, y) {
        this.flag = false;

        this.x = x;
        this.y = y;

        this.hash = (this.y * LAGER_MAP_CANVAS_HEIGHT) + this.x;

        this.f = -1;
        this.g = -1;
        this.h = -1;

        this.parent = null;
    }

    Update(
        start_x,
        start_y,
        end_x,
        end_y,
        parent=null,
    ) {
        this.flag = true;
        this.distance = 0;

        // Heuristic
        this.g = this.Heuristic(start_x, start_y);
        this.h = this.Heuristic(end_x, end_y);
        this.f = this.g + this.h;

        this.parent = parent;
        if (this.parent) {
            this.distance = parent.distance;
            this.distance += parent.x == this.x || parent.y == this.y ? 10 : 14;
        }
    }

    Reset() { this.flag = false; }
    get IsSet() { return this.flag; }

    // Manhattan distance
    Heuristic(x1, y1) {
        return Math.pow(x1 - this.x, 2) + Math.pow(y1 - this.y, 2);
    }

    /**
     * 
     * @param {AstarNode} node 
     */
    SetParentIfDistanceLess(node) {
        let distance = node.distance;
        distance += this.x === node.x || this.y === node.y ? 10 : 14;

        if (this.distance > distance) {
            this.parent = node;
            this.distance = distance;
        }
    }
}

class AstarNodeSet {
    constructor() {
        this.tree = new AVLTree();
    }

    get size() { return this.tree.Size; }

    add(item) {
        let target = this.tree.Get(item.f);
        if (!target) this.tree.Insert(item.f, [item]);
        else target.push(item);
    }

    pop() {
        let min = this.tree.Min;
        let result = min.pop();
        if (min.length === 0) this.tree.Delete(result.f);
        return result;
    }
}

/**
 * Represents how balanced a node's left and right children are.
 *
 * @private
 */
const AVL_BALANCE_STATE = {
    UNBALANCED_RIGHT: 1,
    SLIGHTLY_UNBALANCED_RIGHT: 2,
    BALANCED: 3,
    SLIGHTLY_UNBALANCED_LEFT: 4,
    UNBALANCED_LEFT: 5,
};

class AVLNode {
    left = null;
    right = null;
    height = null;
    key = undefined;
    value = undefined;

    /**
     * Creates a new AVL Tree node.
     *
     * @private
     * @param {Object} key The key of the new node.
     * @param {Object} value The value of the new node.
     */
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }

    /**
     * Performs a right rotate on this node.
     *
     *       b                           a
     *      / \                         / \
     *     a   e -> b.RotateRight() -> c   b
     *    / \                             / \
     *   c   d                           d   e
     *
     * @return {AVLNode} The root of the sub-tree; the node where this node used to be.
     */
    RotateRight() {
        var other = this.left;
        this.left = other.right;
        other.right = this;
        this.height = Math.max(this.LeftHeight(), this.HightHeight()) + 1;
        other.height = Math.max(other.LeftHeight(), this.height) + 1;
        return other;
    }

    /**
     * Performs a left rotate on this node.
     *
     *     a                              b
     *    / \                            / \
     *   c   b   -> a.RotateLeft() ->   a   e
     *      / \                        / \
     *     d   e                      c   d
     *
     * @return {AVLNode} The root of the sub-tree; the node where this node used to be.
     */
    RotateLeft() {
        var other = this.right;
        this.right = other.left;
        other.left = this;
        this.height = Math.max(this.LeftHeight(), this.HightHeight()) + 1;
        other.height = Math.max(other.HightHeight(), this.height) + 1;
        return other;
    }

    /**
     * Convenience function to Get the height of the left child of the node,
     * returning -1 if the node is null.
     *
     * @return {number} The height of the left child, or -1 if it doesn't exist.
     */
    LeftHeight() {
        if (!this.left) return -1;
        return this.left.height;
    }

    /**
     * Convenience function to Get the height of the right child of the node,
     * returning -1 if the node is null.
     *
     * @return {number} The height of the right child, or -1 if it doesn't exist.
     */
    HightHeight() {
        if (!this.right) return -1;
        return this.right.height;
    }
}

class AVLTree {
    _root = null;
    _size = 0;

    /**
     * Creates a new AVL Tree.
     *
     * @param {Object} settings 
     *  custom_compare: An optional custom compare function (a, b) => ...
     *  custom_update: An optional custom update function (new_value, old_value) => ....
     */
    constructor(settings={
        custom_compare: undefined,
        custom_update: undefined,
    }) {
        if (settings.custom_compare) this._Compare = settings.custom_compare;
        if (settings.custom_update) this._Update = settings.custom_update;
    }

    /**
     * Inserts a new node with a specific key into the tree.
     * 
     * If the key existis the value will be update
     *
     * @param {Object} key The key being inserted.
     * @param {Object} value The value being inserted.
     */
    Insert(key, value) {
        this._root = this._Insert(key, value, this._root);
        this._size++;
    }

    /**
     * Deletes a node with a specific key from the tree.
     *
     * @param {Object} key The key being deleted.
     */
    Delete(key) {
        this._root = this._Delete(key, this._root);
        this._size--;
    }

    /**
     * Gets the value of a node within the tree with a specific key.
     *
     * @param {Object} key The key being searched for.
     * @return {Object} The value of the node or null if it doesn't exist.
     */
    Get(key) {
        if (this._root === null || key == undefined) return undefined;
        return this._Get(key, this._root)?.value;
    }

    /**
     * Gets whether a node with a specific key is within the tree.
     *
     * @param {Object} key The key being searched for.
     * @return {boolean} Whether a node with the key exists.
     */
    Contains(key) {
        if (this._root === null) return false;
        return !!this._Get(key, this._root);
    }

    get Min() { return this._MinValueNode()?.value; }
    get Max() { return this._MaxValueNode()?.value; }

    /**
     * @return {number} The size of the tree.
     */
    get Size() { return this._size; }
    
    /**
     * @return {boolean} Whether the tree is empty.
     */
    get IsEmpty() { return this.size === 0; }

    /**
     * Gets the minimum value node, rooted in a particular node.
     *
     * @private
     * @param {AVLNode} root The node to search.
     * @return {AVLNode} The node with the minimum key in the tree.
     */
    _MinValueNode() {
        var current = this._root;
        while (current.left) current = current.left;
        return current;
    }

    /**
     * Gets the maximum value node, rooted in a particular node.
     *
     * @private
     * @param {AVLNode} root The node to search.
     * @return {AVLNode} The node with the maximum key in the tree.
     */
    _MaxValueNode() {
        var current = this._root;
        while (current.right) current = current.right;
        return current;
    }

    /**
     * Compares two keys with each other.
     *
     * @private
     * @param {Object} a The first key to compare.
     * @param {Object} b The second key to compare.
     * @return {number} -1, 0 or 1 if a < b, a == b or a > b respectively.
     */
    _Compare(a, b) {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
    }

    /**
     * Gives a new value to be assigned when the key already exists
     * 
     * @param {Object} new_value The values given for the update
     * @param {Object} old_value The current value
     * @returns {Object} The value to be assigned node
     */
    _Update(new_value, old_value) { return new_value; } //eslint-disable-line

    /**
     * Inserts a new node with a specific key into the tree.
     *
     * @private
     * @param {Object} key The key being inserted.
     * @param {Object} value The value being inserted.
     * @param {AVLNode} root The root of the tree to Insert in.
     * @return {AVLNode} The new tree root.
     */
    _Insert(key, value, root) {
        // Perform regular BST insertion
        if (root === null) return new AVLNode(key, value);

        if (this._Compare(key, root.key) < 0) root.left = this._Insert(key, value, root.left);
        else if (this._Compare(key, root.key) > 0) root.right = this._Insert(key, value, root.right);
        else {
            // It's a duplicate so insertion failed, decrement size to make up for it
            this._size--;
            root.value = this._Update(value, root.value);
            return root;
        }

        // Update height and rebalance tree
        root.height = Math.max(root.LeftHeight(), root.HightHeight()) + 1;
        var balanceState = this._GetBalanceState(root);

        if (balanceState === AVL_BALANCE_STATE.UNBALANCED_LEFT) {
            if (this._Compare(key, root.left.key) < 0) {
                // Left left case
                root = root.RotateRight();
            } else {
                // Left right case
                root.left = root.left.RotateLeft();
                return root.RotateRight();
            }
        }

        if (balanceState === AVL_BALANCE_STATE.UNBALANCED_RIGHT) {
            if (this._Compare(key, root.right.key) > 0) {
                // Right right case
                root = root.RotateLeft();
            } else {
                // Right left case
                root.right = root.right.RotateRight();
                return root.RotateLeft();
            }
        }

        return root;
    }

    /**
     * Deletes a node with a specific key from the tree.
     *
     * @private
     * @param {Object} key The key being deleted.
     * @param {AVLNode} root The root of the tree to Delete from.
     * @return {AVLNode} The new tree root.
     */
    _Delete(key, root) {
        // Perform regular BST deletion
        if (root === null) {
            this._size++;
            return root;
        }

        if (this._Compare(key, root.key) < 0) {
            // The key to be deleted is in the left sub-tree
            root.left = this._Delete(key, root.left);
        } else if (this._Compare(key, root.key) > 0) {
            // The key to be deleted is in the right sub-tree
            root.right = this._Delete(key, root.right);
        } else {
            // root is the node to be deleted
            if (!root.left && !root.right) {
                root = null;
            } else if (!root.left && root.right) {
                root = root.right;
            } else if (root.left && !root.right) {
                root = root.left;
            } else {
                // AVLNode has 2 children, Get the in-order successor
                var inOrderSuccessor = this._MinValueNode();
                root.key = inOrderSuccessor.key;
                root.value = inOrderSuccessor.value;
                root.right = this._Delete(inOrderSuccessor.key, root.right);
            }
        }

        if (root === null) {
            return root;
        }

        // Update height and rebalance tree
        root.height = Math.max(root.LeftHeight(), root.HightHeight()) + 1;
        var balanceState = this._GetBalanceState(root);

        if (balanceState === AVL_BALANCE_STATE.UNBALANCED_LEFT) {
            // Left left case
            if (this._GetBalanceState(root.left) === AVL_BALANCE_STATE.BALANCED ||
                this._GetBalanceState(root.left) === AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_LEFT) {
                return root.RotateRight();
            }
            // Left right case
            if (this._GetBalanceState(root.left) === AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_RIGHT) {
                root.left = root.left.RotateLeft();
                return root.RotateRight();
            }
        }

        if (balanceState === AVL_BALANCE_STATE.UNBALANCED_RIGHT) {
            // Right right case
            if (this._GetBalanceState(root.right) === AVL_BALANCE_STATE.BALANCED ||
                this._GetBalanceState(root.right) === AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_RIGHT) {
                return root.RotateLeft();
            }
            // Right left case
            if (this._GetBalanceState(root.right) === AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_LEFT) {
                root.right = root.right.RotateRight();
                return root.RotateLeft();
            }
        }

        return root;
    }

    /**
     * Gets the value of a node within the tree with a specific key.
     *
     * @private
     * @param {Object} key The key being searched for.
     * @param {AVLNode} root The root of the tree to search in.
     * @return {Object} The node or null if it doesn't exist.
     */
    _Get(key, root) {
        var result = this._Compare(key, root.key);

        if (result === 0) return root;

        if (result < 0) {
            if (!root.left) return null;
            return this._Get(key, root.left);
        }

        if (!root.right) return null;

        return this._Get(key, root.right);
    }

    /**
     * Gets the balance state of a node, indicating whether the left or right
     * sub-trees are unbalanced.
     *
     * @private
     * @param {AVLNode} node The node to Get the difference from.
     * @return {BalanceState} The BalanceState of the node.
     */
    _GetBalanceState(node) {
        var heightDifference = node.LeftHeight() - node.HightHeight();
        switch (heightDifference) {
            case -2: return AVL_BALANCE_STATE.UNBALANCED_RIGHT;
            case -1: return AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_RIGHT;
            case 1: return AVL_BALANCE_STATE.SLIGHTLY_UNBALANCED_LEFT;
            case 2: return AVL_BALANCE_STATE.UNBALANCED_LEFT;
            default: return AVL_BALANCE_STATE.BALANCED;
        }
    }

    Traversal() {
        if (this._root === null) return;
        let result = [];
        this._Traversal(this._root, result);
        return result;
    }

    _Traversal(root, buffer) {
        if (root === null) return; 
        this._Traversal(root.left, buffer);
        buffer.push(root.value);
        this._Traversal(root.right, buffer);
    }
}
